import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import BasketService from "../../shared/service/BasketService";
import {Button, ButtonGroup, Col, Label, Row} from "reactstrap";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {OrderCheckOut} from "../../shared/layaout/sigma/OrderCheckOut";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import Translate from "../../shared/language/Translate";
import {getDnaWebhookServerBase, PAGE_MODE, SERVER_URL} from "../../shared/utils/Constants";
import AvField from "../../shared/component/form/AvField";
import {Checkbox} from "primereact/checkbox";
import {toast} from "react-toastify";
import Loading from "../../shared/component/others/Loading";
import {RadioButton} from "primereact/radiobutton";
import RestTableService from "../../shared/service/RestTableService";
import PaymentService from "../../shared/service/PaymentService";
import './dojoButtons.css';
import './orderCheckoutActions.css';
import MemberUserCardService from "../../shared/service/MemberUserCardService";
import MemberUserAddressService from "../../shared/service/MemberUserAddressService";
import AddressService from "../../shared/service/AddressService";
import MemberBillingAddressService from "../../shared/service/MemberBillingAddressService";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import {Dropdown} from "primereact/components/dropdown/Dropdown";
import {InputTextarea} from "primereact/inputtextarea";
import MemberUserNotesService from "../../shared/service/MemberUserNotesService";
import CurrentUserService from "../../shared/service/CurrentUserService";
import {InputMask} from "primereact/inputmask";
import OrderPlacedConfirmation from "./OrderPlacedConfirmation";
import {clearOrderBasketStorage, enrichPlacedOrder, isOrderPlacedReturnUrl, isOrderPlacedReturnFailure, clearOrderPlacedReturnParams, loadPlacedOrderForConfirmation} from "./orderPlacedUtils";


const defaultOrder = {
    id: '', tableBssId: null, saveCard: false, orderType: "Table Order"
};

const defaultMemberUserCard = {
    id: null,
    expireDate: null,
    cvv: null,
    cardNo: '',
    cardHolderName: '',
    defaultCard: true,
    paymentType: "CARD",
    saveCard: false,
    cardType: 'VISA',
};

const defaultMemberUserAddress = {
    id: null,
    description: '',
    postCode: '',
    city: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    defaultAddress: true,
    saveAddress: false
};

const defaultMemberBillingAddress = {
    id: null,
    description: '',
    postCode: '',
    city: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    defaultAddress: true,
    saveBillingAddress: false
};

export default class ApproveOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentSettings: [],
            cardList: [],
            addressList: [],
            filteredAddresses: [],
            billingAddressList: [],
            filteredBillingAddresses: [],
            changeDeliveryAddressDisabled: true,
            isClosed: false,
            openHourMessage: null,
            tables: [],
            sameAsDeliveryAddress: false,
            showDeliveryAddressDetails: false,
            showBillingAddressDetails: false,
            deliveryTypesList: [],
            order: Object.assign({}, defaultOrder),
            memberUserCard: defaultMemberUserCard,
            memberUserAddress: Object.assign({}, defaultMemberUserAddress),
            memberUserAddressTemp: Object.assign({}, defaultMemberUserAddress),
            memberBillingAddress: defaultMemberBillingAddress,
            memberBillingAddressTemp: Object.assign({}, defaultMemberBillingAddress),
            confirmButtonName: 'Confirm Order',
            loading: false,
            applePaySheetOpen: false,
            confirmButtonDisabled: false,
            /** DNA: token fields from last hosted-fields submit when "Save my card" — sent with placeOrder for server persist after capture. */
            dnaSaveCardSnapshot: null,
            checkoutPaymentPanelOpen: true,
            checkoutDeliveryAddressPanelOpen: true,
            checkoutBillingAddressPanelOpen: true,
            checkoutContactPanelOpen: true,
            checkoutAllergiesPanelOpen: false,
            orderPlaced: false,
            placedOrder: null
        }
        this.onClickConfirmOrderButton = this.onClickConfirmOrderButton.bind(this);
        this.basketService = new BasketService();
        this.restTableService = new RestTableService();
        this.paymentService = new PaymentService();
        this.memberUserCardService = new MemberUserCardService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.memberUserAddressService = new MemberUserAddressService();
        this.memberBillingAddressService = new MemberBillingAddressService();
        this.memberUserNotesService = new MemberUserNotesService();
        this.addressService = new AddressService();
        this.merchantBranchService = new MerchantBranchService();
        this.currentUserService = new CurrentUserService();
        this._dnaUnhandledRejectionHandler = null;
    }

    componentWillUnmount() {
        let that = this;
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            that.reloadPage("")
        });
        if (this._dnaUnhandledRejectionHandler) {
            window.removeEventListener('unhandledrejection', this._dnaUnhandledRejectionHandler);
        }
    }

    async componentDidMount() {
        // Mobile Safari can keep stale localStorage across sessions/tabs.
        // Re-sync branch id from domain before any secured API call (X-Softrame-BranchId).
        const domainName = GeneralUtils.getDomainName();
        if (!GeneralUtils.isNullOrEmpty(domainName) && domainName !== "admin") {
            const branchIdByDomain = await this.merchantBranchService.getBranchIdByDomainName(domainName);
            if (!GeneralUtils.isNullOrEmpty(branchIdByDomain) && GeneralUtils.isNullOrEmpty(branchIdByDomain.type) && branchIdByDomain !== 0) {
                localStorage.setItem("merchantBranchId", String(branchIdByDomain));
            }
        }

        // 3DS return: Elavon redirects here with cres and threeDSSessionData; POST to webhook to complete order
        const params = new URLSearchParams(window.location.search);
        const elavonReturn = params.get('elavonReturn');
        const cres = params.get('cres');
        const threeDSSessionData = params.get('threeDSSessionData');
        const paymentLink = params.get('paymentLink');
        const basketId = params.get('basketId');
        if (elavonReturn === '1' && cres && threeDSSessionData) {
            const form = document.createElement('form');
            form.method = 'post';
            form.action = SERVER_URL.replace(/\/$/, '') + '/dispatchio/elavon/webhook';
            const c = document.createElement('input');
            c.type = 'hidden';
            c.name = 'cres';
            c.value = cres;
            form.appendChild(c);
            const t = document.createElement('input');
            t.type = 'hidden';
            t.name = 'threeDSSessionData';
            t.value = threeDSSessionData;
            form.appendChild(t);
            document.body.appendChild(form);
            form.submit();
            return;
        }
        // Payment-links return: post paymentLink + basketId to finalize order server-side.
        if (elavonReturn === '1' && paymentLink && basketId) {
            const form = document.createElement('form');
            form.method = 'post';
            form.action = SERVER_URL.replace(/\/$/, '') + '/dispatchio/elavon/webhook/paymentlink';
            const p = document.createElement('input');
            p.type = 'hidden';
            p.name = 'paymentLink';
            p.value = paymentLink;
            form.appendChild(p);
            const b = document.createElement('input');
            b.type = 'hidden';
            b.name = 'basketId';
            b.value = basketId;
            form.appendChild(b);
            document.body.appendChild(form);
            form.submit();
            return;
        }

        const orderPlacedHandled = await this.tryShowOrderPlacedFromPaymentReturn();
        if (orderPlacedHandled) {
            return;
        }

        document.addEventListener("DOMContentLoaded", function () {
            document.body.addEventListener("click", function () {
                window.history.pushState(null, document.title, window.location.href);
            });
        });
        let that = this;
        window.addEventListener('popstate', function (event) {
            that.reloadPage("")
        });
        this._dnaUnhandledRejectionHandler = (event) => {
            try {
                const reason = event && event.reason ? event.reason : event;
                console.warn("DNA unhandledrejection:", {
                    reason: reason,
                    name: reason && reason.name,
                    code: reason && reason.code,
                    message: reason && reason.message,
                    stack: reason && reason.stack,
                    keys: reason ? Object.keys(reason) : []
                });
            } catch (e) {
                // ignore
            }
        };
        window.addEventListener('unhandledrejection', this._dnaUnhandledRejectionHandler);

        this.currentUserService.getCurrentAdminOrMemberUser().then(responseAdminUser => {
                if (!GeneralUtils.isNullOrEmpty(responseAdminUser) && GeneralUtils.isNullOrEmpty(responseAdminUser.type)) {
                    let memberUserAddress = this.state.memberUserAddress;
                    memberUserAddress["firstName"] = responseAdminUser.firstName;
                    memberUserAddress["lastName"] = responseAdminUser.lastName;
                    memberUserAddress["email"] = responseAdminUser.email;
                    memberUserAddress["mobilePhone"] = responseAdminUser.mobilePhone;

                    this.setState({memberUserAddress: memberUserAddress});
                }
            }
        );

        const response = (await this.merchantBranchSettingsService.getPaymentSettingsInfo(localStorage.getItem("merchantBranchId")));
        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
            let order = this.state.order;
            order["provider"] = response.provider;
            this.setState({
                order: order,
                ...(response.provider === "DNA" ? {
                    checkoutBillingAddressPanelOpen: false,
                    ...(this.state.order.orderType === "Table Order" ? { checkoutContactPanelOpen: false } : {})
                } : {})
            });
            if (!GeneralUtils.isNullOrEmpty(response.paymentSenseUrl)) {
                const script = document.createElement("script");
                script.src = response.paymentSenseUrl;
                script.async = true;
                document.body.appendChild(script);
            }
        }
        this.getDeliveryInformation();
        await this.loadMemberStoreNamesForCheckout();
        await this.getDeliveryTypes();
        await this.getPaymentSettings();
        await this.getNotesAndAllergies();


        document.getElementById('apple-pay-button').addEventListener('click', function (e) {
            that.onClickConfirmOrderButton()
        });


    }

    async getNotesAndAllergies() {
        this.memberUserNotesService.getNotesAndAllergies().then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                let order = this.state.order;
                if (!GeneralUtils.isNullOrEmpty(response.orderNotes)) {
                    order["orderNotes"] = response.orderNotes;
                }
                if (!GeneralUtils.isNullOrEmpty(response.allergies)) {
                    order["allergies"] = response.allergies;
                }
                this.setState({order: order});
            }
        });

    }

    setOrderTypeAndAddresFromMemberPage() {
        const orderType = GeneralUtils.getEffectiveOrderType(this.state.order.orderType);
        if (!GeneralUtils.isNullOrEmpty(orderType)) {
            let order = this.state.order;
            order["orderType"] = orderType;
            this.getBasketInfo(orderType);
            this.setState({
                order: order
            });
            if (orderType == "Collection" ||  orderType == "Table Order") {
                this.setState({
                    sameAsDeliveryAddress: false
                });
            } else if (orderType == "Delivery") {

                this.setState({
                    sameAsDeliveryAddress: true
                });

                let memberUserAddress = this.state.memberUserAddress;
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("postCode")) && localStorage.getItem("postCode") != "undefined") {
                    memberUserAddress["postCode"] = localStorage.getItem("postCode");
                    this.setState({
                        showDeliveryAddressDetails: true, addressOption: "Other"
                    });
                }
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("description")) && localStorage.getItem("description") != "undefined") {
                    memberUserAddress["description"] = localStorage.getItem("description");
                }

                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("addressLine2")) && localStorage.getItem("addressLine2") != "undefined") {
                    memberUserAddress["addressLine2"] = localStorage.getItem("addressLine2");
                }
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("addressLine3")) && localStorage.getItem("addressLine3") != "undefined") {
                    memberUserAddress["addressLine3"] = localStorage.getItem("addressLine3");
                }
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("addressLine4")) && localStorage.getItem("addressLine4") != "undefined") {
                    memberUserAddress["addressLine4"] = localStorage.getItem("addressLine4");
                }
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("city")) && localStorage.getItem("city") != "undefined") {
                    memberUserAddress["city"] = localStorage.getItem("city");
                }

                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("addressLine1")) && localStorage.getItem("addressLine1") != "undefined") {
                    memberUserAddress["addressLine1"] = localStorage.getItem("addressLine1");
                    this.setState({memberUserAddress: memberUserAddress});
                }


            }
        }
    }

    async loadMemberStoreNamesForCheckout() {
        const branchId = localStorage.getItem("merchantBranchId");
        if (GeneralUtils.isNullOrEmpty(branchId) || branchId === "-1") {
            return;
        }
        try {
            const response = await this.merchantBranchService.getStoreInfo(branchId);
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                GeneralUtils.persistMemberStoreNamesFromStoreInfo(response);
            }
        } catch (e) {
            // keep names already loaded from dashboard/topbar if present
        }
    }

    async getDeliveryTypes() {
        var array = [];
        let orderType = null;
        var hasDelivery = false;
        const response = (await this.merchantBranchSettingsService.findByBranchIdForMember(localStorage.getItem("merchantBranchId")));
        if (localStorage.getItem("WEB_ORDER_LICENSE") == "true") {

            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                if (!GeneralUtils.isNullOrEmpty(response.webOrderPaymentOptions)) {

                    var nameArr = response.webOrderPaymentOptions.split(',');
                    for (var i = 0; i < nameArr.length; i++) {
                        if (nameArr[i].indexOf("DELIVERY") > 0) {
                            array.push({
                                name: "Delivery", id: "Delivery"
                            });
                            orderType = "Delivery";
                            hasDelivery = true;
                            this.setState({
                                sameAsDeliveryAddress: true
                            });
                            break;
                        }

                    }

                    for (var i = 0; i < nameArr.length; i++) {
                        if (nameArr[i].indexOf("COLLECTION") > 0) {
                            array.push({
                                name: "Collection", id: "Collection"
                            });

                            if (hasDelivery) {
                                orderType = "Delivery";
                                this.setState({
                                    sameAsDeliveryAddress: true
                                });
                            } else {
                                orderType = "Collection";
                                this.setState({
                                    sameAsDeliveryAddress: false
                                });
                            }

                            break;
                        }

                    }


                }
            }


        }

        if (localStorage.getItem("TABLE_ORDER_LICENSE") == "true") {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                if (!GeneralUtils.isNullOrEmpty(response.tableOrderPaymentOptions)) {
                    array.push({
                        name: "Table Order", id: "Table Order"
                    });
                    orderType = "Table Order";
                    this.setState({
                        sameAsDeliveryAddress: false
                    });
                    if (GeneralUtils.isNullOrEmpty(localStorage.getItem("tableBssId")) && localStorage.getItem("WEB_ORDER_LICENSE") == "true") {
                        if (hasDelivery) {
                            orderType = "Delivery";
                            this.setState({
                                sameAsDeliveryAddress: true
                            });
                        } else {
                            orderType = "Collection";
                            this.setState({
                                sameAsDeliveryAddress: false
                            });
                        }

                    }
                }
            }

        }
        if (array.length === 1) {
            orderType = array[0].id;
            this.setState({
                sameAsDeliveryAddress: orderType === "Delivery"
            });
        }
        //this.getBasketInfo(orderType);
        let order = this.state.order;
        if (!GeneralUtils.isNullOrEmpty(response.scheduledForDelivery)) {
            order["scheduledForDelivery"] = response.scheduledForDelivery;
        } else {
            order["scheduledForDelivery"] = false;
        }
        order["orderTimeForDeliveryList"] = response.orderTimeForDelivery;
        orderType = GeneralUtils.persistCheckoutOrderType(orderType, array);
        order["orderType"] = orderType;
        this.setState({order: order, deliveryTypesList: array}, () => {
            this.setOrderTypeAndAddresFromMemberPage();
            this.applySingleDeliveryTypeIfNeeded();
            if (this.state.order.provider === "DNA" && this.state.order.orderType === "Table Order") {
                this.setState({ checkoutContactPanelOpen: false });
            }
        });

    }

    isDeliveryTypeInList(orderType) {
        return !GeneralUtils.isNullOrEmpty(orderType) && this.showDeliveryType(orderType);
    }

    applySingleDeliveryTypeIfNeeded() {
        const {deliveryTypesList, order} = this.state;
        if (deliveryTypesList.length !== 1) {
            return;
        }
        const singleType = deliveryTypesList[0].id;
        if (!this.isDeliveryTypeInList(order.orderType)) {
            this.onChangeDeliveryType(singleType);
        }
    }

    setAddressToState(itemSub) {
        //let address = {};
        let address = this.state.memberUserAddress;


        address["postCode"] = itemSub.postCode;
        address["description"] = !GeneralUtils.isNullOrEmpty(itemSub.description) ? itemSub.description.replace(" (Default Address)", "") : itemSub.postCode;
        address["addressLine1"] = itemSub.addressLine1;
        address["addressLine2"] = itemSub.addressLine2;
        address["addressLine3"] = itemSub.addressLine3;
        address["addressLine4"] = itemSub.addressLine4;
        address["city"] = itemSub.city;

        return address;
    }

    getDeliveryInformation() {
        this.restTableService.findByMerchantBranchId(localStorage.getItem("merchantBranchId")).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({tables: response, changeDeliveryAddressDisabled: true});
            }
        });

        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("tableBssId"))) {
            let order = this.state.order;
            order["tableBssId"] = localStorage.getItem("tableBssId");
            this.setState({order: order});
        }

        this.memberUserAddressService.findAll().then((response) => {
            let hasDefaultAddress = false;
            let addressOption = this.state.addressOption;
            let memberUserAddress = this.state.memberUserAddress;
            let addressList = [];
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                response.forEach(itemSub => {
                    if (itemSub.defaultAddress) {
                        addressOption = itemSub.id;
                        memberUserAddress = this.setAddressToState(itemSub);
                        hasDefaultAddress = true;
                    }
                });
                addressList = response.slice();
            }
            let showDeliveryAddressDetails = this.state.showDeliveryAddressDetails;
            if (hasDefaultAddress === false) {
                addressOption = "Other";
                showDeliveryAddressDetails = true;
            }
            this.setState({
                addressList: addressList.concat({description: "New", id: "Other"}),
                addressOption,
                memberUserAddress,
                showDeliveryAddressDetails,
            });
        });

        this.memberBillingAddressService.findAll().then((response) => {
            let hasDefaultAddress = false;
            let billingAddressOption = this.state.billingAddressOption;
            let memberBillingAddress = this.state.memberBillingAddress;
            let billingAddressList = [];
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                response.forEach(itemSub => {
                    if (itemSub.defaultAddress) {
                        billingAddressOption = itemSub.id;
                        memberBillingAddress = this.setAddressToState(itemSub);
                        hasDefaultAddress = true;
                    }
                });
                billingAddressList = response.slice();
            }
            let showBillingAddressDetails = this.state.showBillingAddressDetails;
            if (hasDefaultAddress === false) {
                billingAddressOption = "Other";
                showBillingAddressDetails = true;
            }
            this.setState({
                billingAddressList: billingAddressList.concat({description: "New", id: "Other"}),
                billingAddressOption,
                memberBillingAddress,
                showBillingAddressDetails,
            });
        });


    }

    async getCardsOfUser() {
        const response = (await this.memberUserCardService.findAllByMerchantBranchId(localStorage.getItem("merchantBranchId")));

        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            response.forEach(itemSub => {
                if (itemSub.defaultCard) {
                    this.setState({
                        paymentOption: itemSub.id
                    }, () => {
                        const provider = this.state.order.provider;
                        if (provider === "DOJO") {
                            this.createAccessTokenForDojo(itemSub.crossReference, null)
                        } else if (provider === "OPAYO") {
                            this.createAccessTokenForOpayo(itemSub.crossReference, itemSub.id)
                        } else if (provider === "DNA") {
                            const dnaSel = GeneralUtils.memberUserCardToDnaSelectCard(itemSub);
                            if (dnaSel) {
                                this._dnaSelectCardPayload = dnaSel;
                                this.createAccessTokenForDna();
                            }
                        }
                        // ELAVON: do not create token/payment-link on page load — basket total may still be 0
                        // and Elavon rejects "total.amount must be greater than 0". Token is created on Confirm or when user selects payment.
                    })
                }
            })

            this.setState({
                cardList: response
            })
        }

    }

    setDefaultServiceChargeOptions(orderType, data) {
        let defaultServiceChargeOptions = null;
        if (orderType == "Table Order") {
            defaultServiceChargeOptions = data.serviceChargeOptionsTableOrder;
        } else if (orderType == "Delivery") {
            defaultServiceChargeOptions = data.serviceChargeOptionsDelivery;
        } else if (orderType == "Collection") {
            defaultServiceChargeOptions = data.serviceChargeOptions;
        }
        return defaultServiceChargeOptions;

    }

    setDefaultServiceCharge(orderType, data) {
        let defaultServiceCharge = null;
        if (orderType == "Table Order") {
            defaultServiceCharge = data.defaultServiceChargeTableOrder;
        } else if (orderType == "Delivery") {
            defaultServiceCharge = data.defaultServiceChargeDelivery;
        } else if (orderType == "Collection") {
            defaultServiceCharge = data.defaultServiceCharge;
        }
        return defaultServiceCharge;

    }

    async getPaymentSettings() {

        const response = (await this.merchantBranchSettingsService.findByBranchIdForMember(localStorage.getItem("merchantBranchId")));

        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            if (this.state.order.orderType == "Table Order") {
                var arrayList = new Array();
                let hasCardOption = false;
                if (!GeneralUtils.isNullOrEmpty(response.tableOrderPaymentOptions)) {
                    var nameArr = response.tableOrderPaymentOptions.split(',');

                    for (var i = 0; i < nameArr.length; i++) {
                        let data1 = {
                            id: nameArr[i], name: nameArr[i]
                        };
                        if (data1.name == "CARD") {
                            hasCardOption = true;
                        }
                        if (data1.name.indexOf("APPLE PAY") >= 0) {
                            if (window.ApplePaySession && !arrayList.some(item => item.name === data1.name)) {
                                arrayList.push(data1);
                            }
                        } else {
                            arrayList.push(data1);
                        }
                    }
                }

                this.setState({
                    paymentSettings: arrayList,
                    minimumDeliveryBasketPrice: response.minimumDeliveryBasketPrice,
                    isClosed: response.closed,
                    openHourMessage: response.openHourMessage,
                    serviceChargeOptions: this.setDefaultServiceChargeOptions(this.state.order.orderType, response),
                    defaultServiceCharge: this.setDefaultServiceCharge(this.state.order.orderType, response),
                }, () => {
                    if (hasCardOption) {
                        this.getCardsOfUser();
                    }
                })

                if (this.refOrderCheckout != null) {
                    this.refOrderCheckout.setBranchSettings(this.state.order.orderType, this.state.minimumDeliveryBasketPrice, this.state.isClosed, this.state.serviceChargeOptions);
                }
            } else if ((this.state.order.orderType == "Delivery" || this.state.order.orderType == "Collection") && !GeneralUtils.isNullOrEmpty(response.webOrderPaymentOptions)) {
                var nameArr = response.webOrderPaymentOptions.split(',');
                var arrayList = new Array();
                let hasCardOption = false;
                for (var i = 0; i < nameArr.length; i++) {
                    if (nameArr[i].indexOf(this.state.order.orderType.toUpperCase()) > 0) {
                        let data1 = {
                            id: nameArr[i].replace(" (DELIVERY)", "").replace(" (COLLECTION)", ""),
                            name: nameArr[i].replace(" (DELIVERY)", "").replace(" (COLLECTION)", "")
                        };
                        if (data1.name == "CARD") {
                            hasCardOption = true;
                        }
                        if (data1.name.indexOf("APPLE PAY") >= 0) {
                            if (window.ApplePaySession && !arrayList.some(item => item.name === data1.name)) {
                                arrayList.push(data1);
                            }
                        } else {
                            arrayList.push(data1);
                        }
                    }


                }
                this.setState({
                    paymentSettings: arrayList,
                    minimumDeliveryBasketPrice: response.minimumDeliveryBasketPrice,
                    isClosed: response.closed,
                    openHourMessage: response.openHourMessage,
                    serviceChargeOptions: this.setDefaultServiceChargeOptions(this.state.order.orderType, response),
                    defaultServiceCharge: this.setDefaultServiceCharge(this.state.order.orderType, response),
                }, () => {
                    if (hasCardOption) {
                        this.getCardsOfUser();
                    }
                })
                if (this.refOrderCheckout != null) {
                    this.refOrderCheckout.setBranchSettings(this.state.order.orderType, this.state.minimumDeliveryBasketPrice, this.state.isClosed, this.state.serviceChargeOptions);
                }
            }
        }
    }

    handleOrderPlacedSuccess(response) {
        clearOrderBasketStorage();
        localStorage.removeItem("tableBssId");
        const placedOrder = enrichPlacedOrder(response, this.state);
        this.setState({
            loading: false,
            orderPlaced: true,
            placedOrder,
            applePaySheetOpen: false,
            confirmButtonDisabled: true,
            confirmButtonName: 'Confirm Order'
        });
        if (window.history && window.history.pushState) {
            window.history.pushState({orderPlaced: true}, document.title, window.location.pathname);
        }
    }

    /**
     * After 3DS / external payment redirect (Opayo, Elavon, DNA webhook, payment links).
     * Apple Pay completes in-page via handleOrderPlacedSuccess — not this path.
     */
    tryShowOrderPlacedFromPaymentReturn = async () => {
        if (!isOrderPlacedReturnUrl() && !isOrderPlacedReturnFailure()) {
            return false;
        }
        if (isOrderPlacedReturnFailure()) {
            clearOrderPlacedReturnParams();
            toast.warn("Payment could not be completed. Please try again.");
            return false;
        }

        this.setState({loading: true});
        const order = await loadPlacedOrderForConfirmation(this.basketService);
        clearOrderPlacedReturnParams();

        if (!GeneralUtils.isNullOrEmpty(order) && GeneralUtils.isNullOrEmpty(order.type)) {
            this.handleOrderPlacedSuccess(order);
            return true;
        }

        this.setState({loading: false});
        toast.success("Your order has been placed");
        return false;
    }

    renderOrderPlacedConfirmation() {
        return (
            <OrderPlacedConfirmation
                order={this.state.placedOrder}
                onContinueShopping={() => this.reloadPage("")}
            />
        );
    }

    render() {
        if (this.state.orderPlaced && this.state.placedOrder) {
            return this.renderOrderPlacedConfirmation();
        }
        if (!GeneralUtils.isMobile()) {
            return (<div>
                <AvForm>
                    <div>
                        <Row>
                            <Col md={2}>
                            </Col>
                            <Col md={4}>
                                {this.renderDelivery()}
                                {this.renderPayment()}
                            </Col>
                            {GeneralUtils.isAuthenticated() && (GeneralUtils.hasWebOrderLicense() || GeneralUtils.hasTableOrderLicense()) &&
                                <Col md={4}>
                                    {this.renderCheckOut()}
                                </Col>}
                            <Col md={2}>
                            </Col>
                        </Row>

                    </div>
                </AvForm>
                {this.state.loading && !this.state.applePaySheetOpen && <Loading/>}
            </div>);
        } else {
            return (<div>
                <AvForm>
                    <div>
                        <Row>
                            <Col xs={12} md={4}>
                                {this.renderDelivery()}
                                {this.renderCheckOut()}
                                {this.renderPayment()}
                            </Col>
                        </Row>

                    </div>
                </AvForm>
                {this.state.loading && !this.state.applePaySheetOpen && <Loading/>}
            </div>);
        }
    }

    renderBillingRequiredStar() {
        return this.state.order.provider !== "DNA"
            ? <span style={{color: 'red'}}> (*)</span>
            : null;
    }

    renderNewBillingAddress() {
        if (this.state.showBillingAddressDetails || this.state.order.provider === "DNA") {
            return (<div>

                <Row>

                </Row>


                <Row>
                    <Col md="12">
                            <AvGroup>
                                <Label for="email">
                                    <Translate contentKey="merchantBranch.tradingName">Post Code
                                    </Translate>
                                    {this.renderBillingRequiredStar()}
                                </Label>

                                <div className="d-flex align-items-center" style={{gap: '10px'}}>
                                    <div className="flex-grow-1" style={{minWidth: 0}}>
                                        <Dropdown value={this.state.memberBillingAddress.postCode}
                                                  name="postCode"
                                                  ref={elem => this.dropDownBillingAddress = elem}
                                                  className="form-control"
                                                  style={{width: '100%'}}
                                                  disabled={this.state.billingAddressOption != "Other"}
                                                  options={this.state.filteredBillingAddresses}
                                                  onChange={this.__handleChangeBillingAddress} optionLabel="displayString"
                                                  editable placeholder=""/>
                                    </div>
                                    {this.state.billingAddressOption == "Other" &&
                                    <span className="pi pi-search flex-shrink-0" role="button" tabIndex={0}
                                          style={{fontSize: '1.75rem', cursor: 'pointer'}}
                                          onClick={(e) => {
                                              this.searchBillingAddress(e);
                                          }} onKeyDown={(e) => {
                                              if (e.key === 'Enter' || e.key === ' ') {
                                                  e.preventDefault();
                                                  this.searchBillingAddress(e);
                                              }
                                          }}/>}
                                </div>


                            </AvGroup>


                    </Col>

                </Row>


                <Row>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">City
                                </Translate>
                                {this.renderBillingRequiredStar()}
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="city"
                                disabled={this.state.billingAddressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberBillingAddress.city}
                                onChange={this.__handleChangeBillingAddress}/>
                        </AvGroup>
                    </Col>


                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Label
                                </Translate>
                            </Label>

                            <AvField
                                type="text"
                                className="form-control"
                                name="description"
                                disabled={this.state.billingAddressOption != "Other"}
                                value={this.state.memberBillingAddress.description}
                                onChange={this.__handleChangeBillingAddress}>
                            </AvField>

                        </AvGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 1
                                </Translate>
                                {this.renderBillingRequiredStar()}
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine1"
                                disabled={this.state.billingAddressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 50, errorMessage: "You can enter up to 50 characters in this field."
                                    }
                                }}
                                value={this.state.memberBillingAddress.addressLine1}
                                onChange={this.__handleChangeBillingAddress}/>
                        </AvGroup>
                    </Col>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 2
                                </Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine2"
                                disabled={this.state.billingAddressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberBillingAddress.addressLine2}
                                onChange={this.__handleChangeBillingAddress}/>
                        </AvGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 3
                                </Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine3"
                                disabled={this.state.billingAddressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberBillingAddress.addressLine3}
                                onChange={this.__handleChangeBillingAddress}/>
                        </AvGroup>
                    </Col>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 4
                                </Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine4"
                                disabled={this.state.billingAddressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberBillingAddress.addressLine4}
                                onChange={this.__handleChangeBillingAddress}/>
                        </AvGroup>
                    </Col>
                </Row>

                {this.state.billingAddressOption == "Other" && <Row>
                    <Col md="12">
                        <AvGroup>
                            <Checkbox
                                onChange={(e) => this.setCheckedBillingAddress("saveBillingAddress", e.checked)}
                                name="saveBillingAddress"
                                value={this.state.memberBillingAddress.saveBillingAddress}
                                checked={this.state.memberBillingAddress.saveBillingAddress}></Checkbox>

                            <Label for="saveBillingAddress">
                                <Translate contentKey="saveBillingAddress">&nbsp;&nbsp;Save my
                                    address
                                    for future orders</Translate>

                            </Label>
                        </AvGroup>
                    </Col>
                </Row>}

            </div>)
        } else {
            return '';
        }
    }

    renderNewAddress() {

        if (this.state.showDeliveryAddressDetails) {
            return (<div>

                <Row>

                </Row>


                <Row>
                        <Col md="12">
                            <AvGroup>

                                <Label for="email">
                                    <Translate contentKey="merchantBranch.tradingName">Post Code
                                    </Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>

                                <div className="d-flex align-items-center" style={{gap: '10px'}}>
                                    <div className="flex-grow-1" style={{minWidth: 0}}>
                                        <Dropdown ref={elem => this.dropDownAddress = elem}
                                                  value={this.state.memberUserAddress.postCode}
                                                  name="postCode"
                                                  showOnFocus={false}
                                                  className="form-control"
                                                  style={{width: '100%'}}
                                                  disabled={this.state.addressOption != "Other"}
                                                  options={this.state.filteredAddresses}
                                                  onChange={this.__handleChangeAddress} optionLabel="displayString"
                                                  editable placeholder=""/>
                                    </div>
                                    {this.state.addressOption == "Other" &&
                                    <span className="pi pi-search flex-shrink-0" role="button" tabIndex={0}
                                          style={{fontSize: '1.75rem', cursor: 'pointer'}}
                                          onClick={(e) => {
                                              this.searchAddress(e);
                                          }} onKeyDown={(e) => {
                                              if (e.key === 'Enter' || e.key === ' ') {
                                                  e.preventDefault();
                                                  this.searchAddress(e);
                                              }
                                          }}/>}
                                </div>


                            </AvGroup>


                        </Col>

                </Row>

                <Row>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">City
                                </Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="city"
                                disabled={this.state.addressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberUserAddress.city}
                                onChange={this.__handleChangeAddress}/>
                        </AvGroup>
                    </Col>


                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Label
                                </Translate>
                            </Label>

                            <AvField
                                type="text"
                                className="form-control"
                                name="description"
                                disabled={this.state.addressOption != "Other"}
                                value={this.state.memberUserAddress.description}
                                onChange={this.__handleChangeAddress}>
                            </AvField>

                        </AvGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 1
                                </Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine1"
                                disabled={this.state.addressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 50, errorMessage: "You can enter up to 50 characters in this field."
                                    }
                                }}
                                value={this.state.memberUserAddress.addressLine1}
                                onChange={this.__handleChangeAddress}/>
                        </AvGroup>
                    </Col>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 2
                                </Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine2"
                                disabled={this.state.addressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberUserAddress.addressLine2}
                                onChange={this.__handleChangeAddress}/>
                        </AvGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 3
                                </Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine3"
                                disabled={this.state.addressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberUserAddress.addressLine3}
                                onChange={this.__handleChangeAddress}/>
                        </AvGroup>
                    </Col>
                    <Col md="6">
                        <AvGroup>
                            <Label for="email">
                                <Translate contentKey="merchantBranch.tradingName">Address Line 4
                                </Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="addressLine4"
                                disabled={this.state.addressOption != "Other"}
                                validate={{
                                    maxLength: {
                                        value: 255, errorMessage: "You can enter up to 100 characters in this field."
                                    }
                                }}
                                value={this.state.memberUserAddress.addressLine4}
                                onChange={this.__handleChangeAddress}/>
                        </AvGroup>
                    </Col>
                </Row>

                {this.state.addressOption == "Other" && <Row>
                    <Col md="12">
                        <AvGroup>


                            <Checkbox onChange={(e) => this.setCheckedAddress("saveAddress", e.checked)}
                                      name="saveAddress"
                                      value={this.state.memberUserAddress.saveAddress}
                                      checked={this.state.memberUserAddress.saveAddress}></Checkbox>

                            <Label for="firstName">
                                <Translate contentKey="saveAddress">&nbsp;&nbsp;Save my
                                    address
                                    for future orders</Translate>

                            </Label>
                        </AvGroup>
                    </Col>
                </Row>}

            </div>)
        } else {
            return '';
        }
    }

    createAccessTokenForDojo(crossReference, paymentType) {
        var address = this.state.sameAsDeliveryAddress == true ? this.state.memberUserAddress : Number.isInteger(this.state.paymentOption) || this.state.paymentOption == "CARD" ? this.state.memberBillingAddress : null;

        this.paymentService.createToken(localStorage.getItem("merchantBranchId"), crossReference, address, null, null, null, null, null, null, this.state.order.provider).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({accessToken: response.id, crossReference: crossReference, paymentType: paymentType});
                this.renderDOJOFrame(crossReference, paymentType);
            } else {
                this.reloadPage("")
                this.setState({
                    loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
                });
            }
        });
    }

    async getMerchantSessionKeyForOpayo() {
        const response = (await this.paymentService.createToken(localStorage.getItem("merchantBranchId"), null, null, null, null, null, null, null, null, this.state.order.provider));
        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            this.setState({
                accessToken: response.merchantSessionKey
            });
        }

    }

    async createAccessTokenForOpayo(crossReference, cardId) {
        const response = (await this.paymentService.createToken(localStorage.getItem("merchantBranchId"), null, null, null, null, null, null, null, null, this.state.order.provider));
        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            this.renderOpayoFrame(response.merchantSessionKey, crossReference, cardId);
        } else {
            this.reloadPage("")
            this.setState({
                loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
            });
        }

    }

    async createAccessTokenForElavon(crossReference, cardId) {
        let orderData = null;
        if (this.refOrderCheckout != null) {
            orderData = this.refOrderCheckout.getData();
        }
        const amount = orderData && !GeneralUtils.isNullOrEmpty(orderData.totalPrice) ? (Number(orderData.totalPrice)).toFixed(2) : null;
        // getCardsOfUser() may auto-trigger this before checkout totals are ready.
        // Avoid sending null amount to backend (Elavon rejects order create).
        if (GeneralUtils.isNullOrEmpty(amount) || isNaN(Number(amount)) || Number(amount) <= 0) {
            return;
        }
        const currencyCode = "GBP";
        const orderDescription = orderData && !GeneralUtils.isNullOrEmpty(orderData.orderNo) ? ("Order " + orderData.orderNo) : "Order";
        const baseUi = (typeof window !== "undefined" && window.location)
            ? (window.location.origin + window.location.pathname)
                .replace(/\/approveOrder(?:\/)?$/i, "")
                .replace(/\/confirmOrder(?:\/)?$/i, "")
            : GeneralUtils.getUiUrl().replace("/approveOrder", "").replace("/confirmOrder", "");
        // For Elavon fullPageRedirect (payment-links) we return to BACKEND webhook directly,
        // so the order can be finalized without depending on any UI page.
        const backendBase = SERVER_URL.replace(/\/$/, '');
        const webParam = encodeURIComponent(baseUi);
        const returnUrl = backendBase + "/dispatchio/elavon/webhook/paymentlink"
            + (orderData && orderData.id ? ("?basketId=" + orderData.id + "&web=" + webParam) : ("?web=" + webParam));
        // If the shopper cancels, send them back to the site root.
        const cancelUrl = baseUi + "/" + (orderData && orderData.id ? ("?basketId=" + orderData.id) : "");
        const originUrl = baseUi;

        const response = (await this.paymentService.createToken(
            localStorage.getItem("merchantBranchId"),
            crossReference,
            null,
            amount,
            currencyCode,
            orderDescription,
            returnUrl,
            cancelUrl,
            originUrl,
            this.state.order.provider
        ));
        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            this.setState({
                accessToken: response.id,
                elavonOrderHref: response.elavonOrderHref || null,
                elavonPaymentSessionHref: response.elavonPaymentSessionHref || null,
                elavonRedirectUrl: response.redirectUrl || null,
                elavonPaymentLink: response.paymentLink || null,
                ...(crossReference ? { cardIdentifier: crossReference } : {})
            });
            // Saved card akışında (fullPageRedirect) hosted-fields submit'a gerek yok.
            // Hosted-fields'i sadece yeni kart (crossReference null) için başlat.
            if (crossReference == null || GeneralUtils.isNullOrEmpty(crossReference) || !crossReference.includes("stored-cards")) {
                this.initialiseElavonHostedFields(response);
            }
        } else {
            if (response && response.message) {
                toast.warn(response.message);
            } else {
                toast.warn("Card payment failed. Please try again.");
            }
            this.setState({
                loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
            });
        }
    }

    async createAccessTokenForDna() {
        let orderData = null;
        if (this.refOrderCheckout != null) {
            orderData = this.refOrderCheckout.getData();
        }
        const dnaMajor = GeneralUtils.parseDnaAmountMajorUnits(orderData && orderData.totalPrice);
        if (dnaMajor == null) {
            return;
        }
        const amount = dnaMajor.toFixed(2);
        const currencyCode = "GBP";
        const orderDescription = orderData && !GeneralUtils.isNullOrEmpty(orderData.orderNo) ? ("Order " + orderData.orderNo) : "Order";

        const response = (await this.paymentService.createToken(
            localStorage.getItem("merchantBranchId"),
            null,
            null,
            amount,
            currencyCode,
            orderDescription,
            null,
            null,
            null,
            this.state.order.provider,
            orderData && orderData.id ? String(orderData.id) : null
        ));
        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            // For DNA we re-use existing response fields:
            // - merchantSessionKey: Client ID
            // - expiry: Terminal ID
            this.setState({
                dnaClientId: response.merchantSessionKey || null,
                dnaTerminalId: response.expiry || null
            });
            if (!GeneralUtils.isNullOrEmpty(response.paymentSenseUrl)) {
                const script = document.createElement("script");
                script.src = response.paymentSenseUrl;
                script.async = true;
                script.onload = () => this.initialiseDnaHostedFields(response.id, this._dnaSelectCardPayload || null);
                document.body.appendChild(script);
                return;
            }
            // Fallback: if backend didn't send the SDK url, use DNA CDN default
            const script = document.createElement("script");
            script.src = "https://cdn.dnapayments.com/js/hosted-fields/hosted-fields.js";
            script.async = true;
            script.onload = () => this.initialiseDnaHostedFields(response.id, this._dnaSelectCardPayload || null);
            document.body.appendChild(script);
        }
    }

    paymentItem(item) {
        return (
            <div className="field-radiobutton">

                <RadioButton inputId={item.id} name={item.name} value={item.id}
                             onChange={(e) => {
                                 const isCardFlow = e.value == "CARD" || e.value == "WALLET" || Number.isInteger(e.value);
                                 if (isCardFlow && GeneralUtils.isNullOrEmpty(this.state.order.provider)) {
                                     const providerError = new Error("Payment provider is required before card token creation.");
                                     toast.warn(providerError.message);
                                     throw providerError;
                                 }
                                 this.setState({
                                     paymentOption: e.value,
                                     crossReference: null,
                                     // Reset Elavon flow state when switching options/cards
                                     elavonRedirectUrl: null,
                                     elavonPaymentLink: null,
                                     accessToken: null,
                                     elavonOrderHref: null,
                                     elavonPaymentSessionHref: null,
                                 });

                                 this.removeCardIframes();

                                 if ((e.value == "CARD" || e.value == "WALLET") && this.state.order.provider === "DOJO") {
                                     this.createAccessTokenForDojo(null, e.value)
                                 } else if ((e.value == "CARD" || e.value == "WALLET") && this.state.order.provider === "OPAYO") {
                                     this.createAccessTokenForOpayo(null, null)
                                 } else if ((e.value == "CARD" || e.value == "WALLET") && this.state.order.provider === "ELAVON") {
                                     this.createAccessTokenForElavon(null, null)
                                } else if ((e.value == "CARD" || e.value == "WALLET") && this.state.order.provider === "DNA") {
                                    this._dnaSelectCardPayload = null;
                                    this.createAccessTokenForDna();
                                } else if (e.value == "APPLE PAY" && this.state.order.provider === "OPAYO") {
                                    this.getMerchantSessionKeyForOpayo();
                                 }

                                 if (Number.isInteger(e.value)) {
                                     this.state.cardList.forEach(itemSub => {
                                         if (itemSub.id == e.value) {
                                             if (this.state.order.provider === "DOJO") {
                                                 this.createAccessTokenForDojo(itemSub.crossReference, null)
                                             } else if (this.state.order.provider === "OPAYO") {
                                                 this.createAccessTokenForOpayo(itemSub.crossReference, itemSub.id)
                                             } else if (this.state.order.provider === "ELAVON") {
                                                 this.createAccessTokenForElavon(itemSub.crossReference, itemSub.id)
                                            } else if (this.state.order.provider === "DNA") {
                                                this._dnaSelectCardPayload = GeneralUtils.memberUserCardToDnaSelectCard(itemSub) || null;
                                                this.createAccessTokenForDna();
                                            }
                                        }

                                    });

                                 }

                                 this.retryInitPaymentFrames(e.value);
                             }}
                             checked={this.state.paymentOption === item.id}/>

                <label htmlFor={item.id}>&nbsp;&nbsp;{item.name}&nbsp;&nbsp;</label>


            </div>);
    }

    retryInitPaymentFrames(value) {
        if (!(value == "CARD" || value == "WALLET")) {
            return;
        }
        setTimeout(() => {
            if (this.state.paymentOption !== value) {
                return;
            }
            const hasLegacyIframe = document.getElementById("iframe-card-payment") || document.getElementById("iframe-cvv-payment");
            const cardContainer = document.getElementById("card-payment");
            const dnaContainer = document.getElementById("dna-card-payment");
            const hasHostedContent = (cardContainer && cardContainer.childElementCount > 0) || (dnaContainer && dnaContainer.childElementCount > 0);
            if (hasLegacyIframe || hasHostedContent) {
                return;
            }

            if ((value == "CARD" || value == "WALLET") && this.state.order.provider === "DOJO") {
                this.createAccessTokenForDojo(null, value)
            } else if ((value == "CARD" || value == "WALLET") && this.state.order.provider === "OPAYO") {
                this.createAccessTokenForOpayo(null, null)
            } else if ((value == "CARD" || value == "WALLET") && this.state.order.provider === "ELAVON") {
                this.createAccessTokenForElavon(null, null)
            } else if ((value == "CARD" || value == "WALLET") && this.state.order.provider === "DNA") {
                this._dnaSelectCardPayload = null;
                this.createAccessTokenForDna();
            }
        }, 350);
    }

    initialiseElavonHostedFields(accessTokenResponse) {
        if (!window.ElavonHostedFields) {
            return;
        }
        const container = document.getElementById("card-payment");
        if (!container) {
            return;
        }
        container.innerHTML =
            '<div class=\"elavon-card-fields\">' +
            '  <div class=\"elavon-field\"><label>Cardholder Name</label><div class=\"field-height\" id=\"elavon-cardholder-name\"></div></div>' +
            '  <div class=\"elavon-field\"><label>Card Number</label><div class=\"field-height\" id=\"elavon-card-number\"></div></div>' +
            '  <div class=\"elavon-field\"><label>Expiration Date</label><div class=\"field-height\" id=\"elavon-card-exp-date\"></div></div>' +
            '  <div class=\"elavon-field\"><label>CVV</label><div class=\"field-height\" id=\"elavon-card-cvv\"></div></div>' +
            '</div>';

        const fieldTypes = window.ElavonHostedFields.FieldTypes;
        const that = this;
        const hosted = new window.ElavonHostedFields({
            sessionId: accessTokenResponse.id,
            fields: {
                cardholderName: { wrapperId: 'elavon-cardholder-name', className: 'field-height' },
                cardNumber: { wrapperId: 'elavon-card-number', className: 'field-height' },
                cardExpirationDate: { wrapperId: 'elavon-card-exp-date', className: 'field-height', placeholder: 'MM/YY' },
                cardCvv: { wrapperId: 'elavon-card-cvv', className: 'field-height', placeholder: 'e.g. 123' }
            },
            styles: {
                'input': {
                    'width': '100%',
                    'padding': '6px 8px',
                    'fontSize': '14px',
                    'minHeight': '36px',
                    'height': '36px',
                    'border': '1px solid #ccc',
                    'borderRadius': '4px',
                    'boxSizing': 'border-box'
                }
            },
            onReady: function () {
                hosted.show();
            },
            messageHandler: function (message) {
                // Debug: hosted fields mesajı 3DS’i tetikliyor mu?
                // (Test sırasında konsolda görmek için bırakılacak; istersen sonra kaldırırız.)
                try {
                    console.debug("ElavonHostedFields message:", message);
                } catch (e) {
                    // ignore
                }
                if (message.fieldType === "cardholderName" && message.isFocused === true) {
                    hosted.removeClass(fieldTypes.cardholderName, 'field-error');
                }
                if (message.fieldType === "cardNumber" && message.isFocused === true) {
                    hosted.removeClass(fieldTypes.cardNumber, 'field-error');
                }
                if (message.fieldType === "cardExpirationDate" && message.isFocused === true) {
                    hosted.removeClass(fieldTypes.cardExpirationDate, 'field-error');
                }
                if (message.fieldType === "cardCvv" && message.isFocused === true) {
                    hosted.removeClass(fieldTypes.cardCvv, 'field-error');
                }
                if (message.type === "hostedCardCreated") {
                    var hostedCardHref = (message.hostedCard && message.hostedCard.href) ? message.hostedCard.href : null;
                    if (message.requires3DS && typeof hosted.start3DS === 'function') {
                        that.elavonPendingHostedCardHref = hostedCardHref;
                        console.debug("ElavonHostedFields: starting 3DS (requires3DS)");
                        hosted.start3DS(message);
                    } else if (message.authenticationRequired && typeof hosted.start3DS === 'function') {
                        that.elavonPendingHostedCardHref = hostedCardHref;
                        console.debug("ElavonHostedFields: starting 3DS (authenticationRequired)");
                        hosted.start3DS(message);
                    } else if (message.requires3DS || message.authenticationRequired) {
                        that.setState({ loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order' });
                        toast.warn('This card requires 3D Secure. Please ensure the latest payment script is loaded.');
                    } else {
                        that.confirmOrder(null, null, hostedCardHref);
                    }
                }
                if (message.type === "authenticationComplete" || message.type === "authenticationSuccess") {
                    var href = (message.hostedCard && message.hostedCard.href) ? message.hostedCard.href : that.elavonPendingHostedCardHref;
                    that.elavonPendingHostedCardHref = null;
                    that.confirmOrder(null, null, href);
                }
                if (message.type === "authenticationRequired") {
                    var hostedCardHref = (message.hostedCard && message.hostedCard.href) ? message.hostedCard.href : null;
                    if (hostedCardHref && typeof hosted.start3DS === 'function') {
                        that.elavonPendingHostedCardHref = hostedCardHref;
                        hosted.start3DS(message);
                    }
                }
                if (message.type === "authenticationFailed" || message.type === "authenticationError" || message.type === "authenticationCancelled") {
                    that.elavonPendingHostedCardHref = null;
                    that.setState({ loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order' });
                    if (message.message) toast.warn(message.message);
                    else toast.warn('3D Secure was cancelled or failed.');
                }

                // Fallback: Some tenants emit 3DS-required on other message types (e.g., payment session updates).
                // If we see the flags and start3DS exists, attempt to start 3DS once.
                if ((message.requires3DS || message.authenticationRequired)
                    && typeof hosted.start3DS === 'function'
                    && message.type !== "hostedCardCreated"
                    && message.type !== "authenticationComplete"
                    && message.type !== "authenticationSuccess"
                    && message.type !== "authenticationFailed"
                    && message.type !== "authenticationError"
                    && message.type !== "authenticationCancelled") {
                    console.debug("ElavonHostedFields: starting 3DS (fallback)", message.type);
                    hosted.start3DS(message);
                }
            },
            hideUntilRequested: true
        });

        this.elavonHostedFields = hosted;
        this.elavonFieldTypes = fieldTypes;
    }

    stopLoading() {
        this.setState({loading: false});
    }

    displayErrors = (errors) => {
        if (errors && errors.length) {
            for (var i = 0; i < errors.length; i++) {
                if (!GeneralUtils.isNullOrEmpty(errors[i].message)) {
                    toast.warn(errors[i].message);
                } else {
                    toast.warn(errors[i].errorType);
                }
            }
        } else {
            toast.warn("An unexpected error has occurred.");
        }
        this.setState({
            loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
        });
    }


    onPaymentCancelled = () => {
        this.setState({
            loading: false,
        });
    }


    onPaymentInitiated = () => {
        this.setState({
            loading: true,
        });
    }

    paymentComplete = (response) => {
        if (response.statusCode == 0) {
            this.confirmOrder();
        } else {
            this.setState({
                loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
            });
            if (!GeneralUtils.isNullOrEmpty(response.message)) {
                toast.warn(response.message);
            } else {
                toast.warn("An unexpected error has occurred.");
            }
        }
    }


    renderDOJOFrame(crossReference, paymentType) {

        const displayErrors = "";

        if (GeneralUtils.isNullOrEmpty(crossReference)) {

            if (paymentType == "CARD") {
                const payConfig = {
                    onIframeLoaded: () => {
                        this.stopLoading()
                    },
                    paymentDetails: {
                        paymentToken: this.state.accessToken
                    },
                    containerId: "card-payment",
                    fontCss: ['https://fonts.googleapis.com/css?family=Do+Hyeon'],
                    styles: {
                        base: {
                            default: {
                                color: "black",
                                textDecoration: "none",
                                fontFamily: "'Do Hyeon', sans-serif",
                                boxSizing: "border-box",
                                padding: ".375rem .75rem",
                                boxShadow: 'none',
                                fontSize: '1rem',
                                borderRadius: '.25rem',
                                lineHeight: '1.5',
                                backgroundColor: '#fff',

                            }, focus: {
                                color: '#495057', borderColor: '#80bdff',
                            }, error: {
                                color: "#B00", borderColor: "#B00"
                            }, valid: {
                                color: "green", borderColor: 'green'
                            }, label: {
                                display: 'none'
                            }
                        }, cv2: {
                            container: {
                                width: "50%", float: "left", boxSizing: "border-box"
                            }, default: {
                                borderRadius: "0 .25rem .25rem 0"
                            }
                        }, expiryDate: {
                            container: {
                                width: "50%", float: "left", borderRadius: '0rem',
                            }, default: {
                                borderRadius: "0", borderRight: "none"
                            },
                        }, cardNumber: {
                            container: {
                                width: "100%", float: "left",
                            }, default: {
                                borderRadius: ".25rem 0 0 .25rem"
                            },
                        }
                    }
                }
                const connectE1 = new window.Connect.ConnectE(payConfig, displayErrors);
                this.setState({connectE: connectE1});
            } else {
                const walletPaymentCallbacksConfig = {
                    onPaymentCancelled: () => {
                        this.onPaymentCancelled()
                    }, onPaymentInitiated: () => {
                        this.onPaymentInitiated()
                    },
                }
                const payConfig = {
                    onIframeLoaded: () => {
                        this.stopLoading()
                    },
                    containerId: 'payment-wallet',
                    paymentDetails: {
                        paymentToken: this.state.accessToken
                    },
                    buttonConfig: {
                        colour: 'white', color: 'white', type: 'order'
                    },
                    emailRequired: false,
                    billingAddressRequired: false,
                    shippingAddressRequired: false,
                    callbacks: walletPaymentCallbacksConfig
                }

                const connectE1 = new window.Connect.Wallet(payConfig, this.displayErrors, this.paymentComplete);
                this.setState({connectE: connectE1, that: this});
            }

        } else {
            const payConfig = {
                onIframeLoaded: () => {
                    this.stopLoading()
                }, paymentDetails: {
                    paymentToken: this.state.accessToken
                }, containerId: "cvv-payment", fontCss: ['https://fonts.googleapis.com/css?family=Do+Hyeon'], styles: {
                    cv2: {
                        default: {
                            color: "black",
                            textDecoration: "none",
                            fontFamily: "'Do Hyeon', sans-serif",
                            boxSizing: "border-box",
                            padding: ".375rem .75rem",
                            boxShadow: 'none',
                            fontSize: '1rem',
                            borderRadius: '.25rem',
                            lineHeight: '1.5',
                            backgroundColor: '#fff'
                        }, focus: {
                            color: '#495057',
                            backgroundColor: '#fff',
                            borderColor: '#80bdff',
                            outline: '0',
                            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
                        }, error: {
                            color: "#B00", borderColor: "#B00"
                        }, valid: {
                            color: "green"
                        }, label: {
                            display: 'none'
                        }, container: {
                            width: "50%", float: "left", paddingLeft: "5px", boxSizing: "border-box"
                        },
                    },

                }, text: {
                    cv2: {
                        label: "CVV", placeholder: "CVV"
                    }
                }
            };
            const connectE1 = new window.Connect.ConnectERecurringPayment(payConfig, displayErrors);
            this.setState({connectE: connectE1});
        }
    }

    renderPaymentMethods() {
        let form = [];
        const rawCardsForList = this.state.order.provider === "DNA"
            ? this.state.cardList.filter((c) => GeneralUtils.isDnaTokenWalletMemberCard(c))
            : this.state.cardList;
        // Defensive: sometimes API returns duplicated saved-card rows; render each card id once.
        const seenCardIds = new Set();
        const cardsForList = rawCardsForList.filter((c) => {
            const id = c && c.id;
            if (id == null) return true;
            if (seenCardIds.has(id)) return false;
            seenCardIds.add(id);
            return true;
        });
        this.state.paymentSettings.forEach(paymentSettings => {
            if (paymentSettings.name == "CARD") {
                cardsForList.forEach(itemSub => {
                    form.push(this.paymentItem(itemSub));
                    // DNA token-wallet saved cards use DNA hosted-fields for CSC; do NOT render legacy recurring CVV iframe.
                    if (this.state.order.provider === "DNA") {
                        form.push(
                            Number.isInteger(this.state.paymentOption)
                            && this.state.paymentOption === itemSub.id
                            && <div id="dna-card-payment"></div>
                        );
                    } else {
                        let divId = "cvv-payment" + itemSub.id;
                        form.push(Number.isInteger(this.state.paymentOption) && this.state.paymentOption === itemSub.id && <div id={divId}>
                        </div>);
                    }
                    form.push(<p></p>);
                });
            }

        });

        this.state.paymentSettings.forEach(itemSub => {
            form.push(this.paymentItem(itemSub));
            form.push(<p></p>);
            if (itemSub.name == "CARD") {
                // Elavon hosted fields container'i hem yeni kart (paymentOption == "CARD")
                // hem de kayıtlı kart (paymentOption integer) seçilince DOM'da olmalı.
                const showElavonFields = this.state.order.provider === "ELAVON" && this.state.paymentOption != null;
                // Saved card: paymentOption is not "CARD"
                const isSavedElavonCard = this.state.order.provider === "ELAVON" && this.state.paymentOption !== "CARD";
                // If saved-card is using redirect (payment-link), keep hidden.
                // If saved-card is using hosted-fields (feature-flagged), show so shopper can enter CVV.
                const hideElavonFieldsForSavedCard = isSavedElavonCard && !GeneralUtils.isNullOrEmpty(this.state.elavonRedirectUrl);
                form.push(showElavonFields && <div id="card-payment"
                    style={hideElavonFieldsForSavedCard ? {
                        position: 'absolute',
                        width: 0,
                        height: 0,
                        overflow: 'hidden',
                        visibility: 'hidden',
                        pointerEvents: 'none'
                    } : {
                        position: 'static',
                        width: 'auto',
                        height: 'auto',
                        overflow: 'visible',
                        visibility: 'visible',
                        pointerEvents: 'auto'
                    }}>
                </div>);

                // Opayo drop-in checkout container (new card only).
                const showOpayoNewCardFields = this.state.order.provider === "OPAYO" && this.state.paymentOption === "CARD";
                form.push(showOpayoNewCardFields && <div id="card-payment"></div>);

                // DNA hosted fields container
                // New-card flow: render hosted-fields right under the "CARD" option.
                const showDnaNewCardFields = this.state.order.provider === "DNA" && this.state.paymentOption === "CARD";
                form.push(showDnaNewCardFields && <div id="dna-card-payment"></div>);

                // "Save my card" şimdilik yalnızca DNA akışında gösterilsin.
                form.push((this.state.order.provider === "DNA" && (this.state.paymentOption == "CARD" || this.state.paymentOption == "WALLET")) && <div>
                    <Row>
                        <Col md="12">
                            <AvGroup>
                                <Checkbox onChange={(e) => this.setChecked("saveCard", e.checked)}
                                          name="saveCard"
                                          value={this.state.order.saveCard}
                                          checked={this.state.order.saveCard}></Checkbox>
                                <Label for="firstName">
                                    <Translate contentKey="saveCard">&nbsp;&nbsp;Save my card
                                        for future orders</Translate>
                                </Label>
                            </AvGroup>
                        </Col>
                    </Row>
                </div>)
                form.push(<p></p>);

            }

            if (itemSub.name == "WALLET") {
                form.push(<div id="payment-wallet">
                </div>);
            }
        });

        return form;
    }

    setChecked = (name, value) => {
        let order = this.state.order;
        order[name] = value;
        this.setState({order: order});
    }

    setCheckedAddress = (name, value) => {
        let memberUserAddress = this.state.memberUserAddress;
        memberUserAddress[name] = value;
        this.setState({memberUserAddress: memberUserAddress});
    }

    setCheckedBillingAddress = (name, value) => {
        let memberBillingAddress = this.state.memberBillingAddress;
        memberBillingAddress[name] = value;
        this.setState({memberBillingAddress: memberBillingAddress});
    }

    setSameDeliveryAddress = (name, value) => {
        this.setState({sameAsDeliveryAddress: value});
        if (value) {
            let memberBillingAddress = this.state.memberBillingAddress;
            memberBillingAddress["saveBillingAddress"] = false;
            this.setState({memberBillingAddress: memberBillingAddress});
        }
    }

    removeCardIframes() {
        var frame = document.getElementById("iframe-card-payment");
        if (frame != null) {
            frame.parentNode.removeChild(frame);
        }

        var frame = document.getElementById("iframe-cvv-payment");
        if (frame != null) {
            frame.parentNode.removeChild(frame);
        }

        var frame = document.getElementById("iframe-payment-wallet");
        if (frame != null) {
            frame.parentNode.removeChild(frame);
        }

        // Clear hosted-fields containers
        var elavonContainer = document.getElementById("card-payment");
        if (elavonContainer != null) {
            elavonContainer.innerHTML = "";
        }
        var dnaContainer = document.getElementById("dna-card-payment");
        if (dnaContainer != null) {
            dnaContainer.innerHTML = "";
        }
        if (this.dnaHostedFields && typeof this.dnaHostedFields.destroy === "function") {
            try {
                this.dnaHostedFields.destroy();
            } catch (e) {
                // ignore
            }
        }

    }

    initialiseDnaHostedFields(accessToken, selectCardPayload) {
        const container = document.getElementById("dna-card-payment");
        if (!container) return;

        const tokenMode = selectCardPayload != null && typeof selectCardPayload === "object";

        if (tokenMode) {
            container.innerHTML =
                '<div class="elavon-card-fields">' +
                '  <div class="elavon-field"><div class="field-height" id="dna-token-cvv"></div></div>' +
                '</div>';
        } else {
            container.innerHTML =
                '<div class="elavon-card-fields">' +
                '  <div class="elavon-field"><label>Cardholder Name</label><div class="field-height" id="dna-cardholder-name"></div></div>' +
                '  <div class="elavon-field"><label>Card Number</label><div class="field-height" id="dna-card-number"></div></div>' +
                '  <div class="elavon-field"><label>Expiration Date</label><div class="field-height" id="dna-card-exp-date"></div></div>' +
                '  <div class="elavon-field"><label>CVV</label><div class="field-height" id="dna-card-cvv"></div></div>' +
                '</div>';
        }

        // Ensure 3DS container exists outside form
        let threeDs = document.getElementById("dna-three-d-secure");
        if (!threeDs) {
            threeDs = document.createElement("div");
            threeDs.id = "dna-three-d-secure";
            threeDs.style.position = "fixed";
            threeDs.style.left = "0";
            threeDs.style.top = "0";
            threeDs.style.width = "100%";
            threeDs.style.height = "100%";
            threeDs.style.background = "rgba(0,0,0,0.6)";
            threeDs.style.display = "none";
            threeDs.style.zIndex = "9999";
            document.body.appendChild(threeDs);
        }

        if (!window.dnaPayments || !window.dnaPayments.hostedFields || typeof window.dnaPayments.hostedFields.create !== "function") {
            return;
        }

        const styles = {
            input: {
                'width': '100%',
                'padding': '6px 8px',
                'fontSize': '14px',
                'minHeight': '36px',
                'height': '36px',
                'border': '1px solid #ccc',
                'borderRadius': '4px',
                'boxSizing': 'border-box'
            }
        };

        const fields = tokenMode
            ? {
                tokenizedCardCvv: {
                    container: document.querySelector('#dna-token-cvv'),
                    placeholder: 'CSC/CVV'
                }
            }
            : {
                cardholderName: { container: document.querySelector('#dna-cardholder-name'), placeholder: 'Cardholder name' },
                cardNumber: { container: document.querySelector('#dna-card-number'), placeholder: 'Card number' },
                expirationDate: { container: document.querySelector('#dna-card-exp-date'), placeholder: 'Expiry date' },
                cvv: { container: document.querySelector('#dna-card-cvv'), placeholder: 'CSC/CVV' }
            };

        window.dnaPayments.hostedFields.create({
            // Current DNA credentials are sandbox; force test mode to avoid live/test mismatch.
            isTestMode: GeneralUtils.isDnaHostedFieldsTestMode(),
            accessToken: accessToken,
            // Some SDK builds prefer auth object instead of top-level accessToken.
            auth: {
                access_token: accessToken,
                token_type: 'Bearer'
            },
            styles: styles,
            threeDSecure: { container: threeDs },
            fields
        }).then((hf) => {
            this.dnaHostedFields = hf;
            hf.on('dna-payments-three-d-secure-show', () => { threeDs.style.display = "block"; });
            hf.on('dna-payments-three-d-secure-hide', () => { threeDs.style.display = "none"; });
            if (tokenMode && typeof hf.selectCard === "function") {
                try {
                    hf.selectCard(selectCardPayload);
                } catch (e) {
                    try { console.warn("DNA selectCard failed:", e); } catch (e2) { /* ignore */ }
                }
            }
        }).catch(() => {
            // Keep other integrations working
        });
    }

    onChangeDeliveryType(value) {
        localStorage.setItem("orderType", value);
        let order = this.state.order;
        order["orderType"] = value;
        order["saveCard"] = false;
        this.setState({
            order: order,
            paymentOption: this.state.order.provider == "OPAYO" ? this.state.order.paymentOption : null,
            checkoutContactPanelOpen: !(this.state.order.provider === "DNA" && value === "Table Order"),
        });
        if (this.refOrderCheckout != null) {
            this.refOrderCheckout.setBranchSettings(value, this.state.minimumDeliveryBasketPrice, this.state.isClosed, this.state.serviceChargeOptions);
        }
        if (this.state.order.orderType == "Delivery") {
            this.setState({
                sameAsDeliveryAddress: true
            });
        } else {
            this.setState({
                sameAsDeliveryAddress: false
            });
        }


        this.getPaymentSettings();
        this.getBasketInfo(value);
        this.removeCardIframes();
    }

    renderDeliveryTypes() {
        let form = [];
        const isMobile = GeneralUtils.isMobile();
        const deliveryButtonStyle = {
            flex: "1 1 0",
            minWidth: 0,
            whiteSpace: "nowrap",
            ...(isMobile ? {
                paddingLeft: "6px",
                paddingRight: "6px",
                fontSize: "12px"
            } : {
                paddingLeft: "8px",
                paddingRight: "8px",
                fontSize: "0.8125rem"
            })
        };
        form.push(<ButtonGroup className="delivery-type-group" style={{
            display: "flex",
            width: "100%",
            flexWrap: "nowrap",
            gap: isMobile ? "4px" : "6px"
        }}>
            {this.showDeliveryType("Delivery") && <Button
                color="primary"
                outline
                className="delivery-type-btn"
                style={deliveryButtonStyle}
                onClick={(e) => {
                    this.onChangeDeliveryType("Delivery")
                }}
                active={this.state.order.orderType === "Delivery"}
            >
                <span style={{display: "inline-flex", alignItems: "center", gap: "6px"}}>
                    <i className="material-icons delivery-type-icon" aria-hidden="true">two_wheeler</i>
                    <span>Delivery</span>
                </span>
            </Button>}
            {this.showDeliveryType("Collection") && <Button
                color="primary"
                outline
                className="delivery-type-btn"
                style={deliveryButtonStyle}
                onClick={(e) => {
                    this.onChangeDeliveryType("Collection")
                }}
                active={this.state.order.orderType === "Collection"}
            >
                <span style={{display: "inline-flex", alignItems: "center", gap: "6px"}}>
                    <i className="material-icons delivery-type-icon" aria-hidden="true">storefront</i>
                    <span>Collection</span>
                </span>
            </Button>}
            {this.showDeliveryType("Table Order") && <Button
                color="primary"
                outline
                className="delivery-type-btn"
                style={deliveryButtonStyle}
                onClick={(e) => {
                    this.onChangeDeliveryType("Table Order")
                }}
                active={this.state.order.orderType === "Table Order"}
            >
                <span style={{display: "inline-flex", alignItems: "center", gap: "6px"}}>
                    <i className="material-icons delivery-type-icon" aria-hidden="true">restaurant_menu</i>
                    <span>Table Order</span>
                </span>
            </Button>}


        </ButtonGroup>);

        return form;
    }

    showDeliveryType(type) {
        var showDeliveryType = false;
        for (var i = 0; i < this.state.deliveryTypesList.length; i++) {
            if (this.state.deliveryTypesList[i].name == type) {
                showDeliveryType = true;
            }
        }

        return showDeliveryType
    }

    toggleCheckoutPanel(stateKey) {
        this.setState((prev) => ({ [stateKey]: !prev[stateKey] }));
    }

    renderCollapsibleCheckoutPanel({ stateKey, buttonId, bodyId, contentKey, fallback, children }) {
        const open = this.state[stateKey];
        return (
            <section
                className={`co-checkout-panel co-checkout-panel--collapsible${open ? '' : ' co-checkout-panel--collapsed'}`}
                aria-labelledby={buttonId}
            >
                <h2 className="co-checkout-panel__head co-checkout-panel__head--toggle">
                    <button
                        type="button"
                        id={buttonId}
                        className="co-checkout-panel__toggle"
                        aria-expanded={open}
                        aria-controls={bodyId}
                        onClick={() => this.toggleCheckoutPanel(stateKey)}
                    >
                        <span className="co-checkout-panel__toggle-label">
                            <Translate contentKey={contentKey}>{fallback}</Translate>
                        </span>
                        <i className="material-icons co-checkout-panel__chevron" aria-hidden="true">expand_more</i>
                    </button>
                </h2>
                <div id={bodyId} className="co-checkout-panel__body" hidden={!open}>
                    {children}
                </div>
            </section>
        );
    }

    renderOrderTime(title) {
        const isDeliver = title === "Deliver By";
        const panelId = isDeliver ? "co-checkout-deliver-by-heading" : "co-checkout-ready-by-heading";
        const contentKey = isDeliver ? "order.checkout.deliverBy" : "order.checkout.readyBy";

        return (
            <section className="co-checkout-panel" aria-labelledby={panelId}>
                <h2 id={panelId} className="co-checkout-panel__head">
                    <Translate contentKey={contentKey}>{title}</Translate>
                </h2>
                <div className="co-checkout-panel__body">
                    <Row>
                        <Col md={12}>
                            <AvGroup>
                                <Label for="orderTimeForDelivery" className="sr-only">
                                    <Translate contentKey="order.checkout.timeSlot">Time slot</Translate>
                                </Label>
                                <AvField
                                    id="orderTimeForDelivery"
                                    type="select"
                                    name="orderTimeForDelivery"
                                    disabled={false}
                                    value={this.state.order.orderTimeForDelivery}
                                    onChange={this.__handleChangeOrder}>
                                    {this.state.order.orderTimeForDeliveryList.map(element => (
                                        <option value={element.id} key={element.name}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </Col>
                    </Row>
                </div>
            </section>
        );
    }

    isDnaTableOrderContactOptional() {
        return this.state.order.provider === "DNA" && this.state.order.orderType === "Table Order";
    }

    renderContactRequiredStar() {
        return this.isDnaTableOrderContactOptional()
            ? null
            : <span style={{color: 'red'}}> (*)</span>;
    }

    renderUserInfo() {
        let form = [];
        form.push(<div><Row>
            <Col md="6">
                <AvGroup>
                    <Label for="email">
                        <Translate contentKey="merchantBranch.tradingName">First Name
                        </Translate>
                    </Label>
                    <AvField
                        type="text"
                        className="form-control"
                        name="firstName"
                        disabled={true}
                        validate={{
                            maxLength: {
                                value: 20,
                                errorMessage: "You can enter up to 255 characters in this field."
                            }
                        }}
                        value={this.state.memberUserAddress.firstName}
                        onChange={this.__handleChangeAddress}/>
                </AvGroup>
            </Col>

            <Col md="6">
                <AvGroup>
                    <Label for="email">
                        <Translate contentKey="merchantBranch.tradingName">Last Name
                        </Translate>
                    </Label>
                    <AvField
                        type="text"
                        className="form-control"
                        name="lastName"
                        disabled={true}
                        validate={{
                            maxLength: {
                                value: 20,
                                errorMessage: "You can enter up to 255 characters in this field."
                            }
                        }}
                        value={this.state.memberUserAddress.lastName}
                        onChange={this.__handleChangeAddress}/>
                </AvGroup>
            </Col>

        </Row>

            <Row>

                <Col md="6">
                    <AvGroup>
                        <Label for="email">
                            <Translate contentKey="merchantBranch.emailAddress">Email
                            </Translate>
                        </Label>
                        <AvField
                            type="email"
                            className="form-control"
                            name="email"
                            disabled={true}
                            validate={{
                                minLength: {
                                    "value": 5, "errorMessage": "Not Valid Email"
                                }, maxLength: {
                                    value: 255,
                                    errorMessage: "You can enter up to 50 characters in this field."
                                }
                            }}
                            value={this.state.memberUserAddress.email}
                            onChange={this.__handleChangeAddress}/>
                    </AvGroup>
                </Col>
                <Col md="6">
                    <AvGroup>
                        <Label for="mobilePhone">
                            <Translate contentKey="contactManagement.mobilePhone">Mobile
                                Phone</Translate>
                            {this.renderContactRequiredStar()}
                        </Label>

                        <InputMask id="mobilePhone"
                                   className="form-control"
                                   disabled={false}
                                   value={this.state.memberUserAddress.mobilePhone}
                                   onChange={this.__handleChangeAddress}
                                   name="mobilePhone"
                                   unmask={true}
                                   mask="(99999) 999999"
                                   placeholder="(07999) 999999"></InputMask>


                    </AvGroup>
                </Col>
            </Row></div>)
        return form;
    }

    renderDelivery() {
        let form = [];

        if (this.state.deliveryTypesList.length > 0) {
            form.push(
                <section className="co-checkout-panel co-checkout-order-type-panel" aria-labelledby="co-checkout-order-type-heading">
                    <h2 id="co-checkout-order-type-heading" className="co-checkout-panel__head">
                        <Translate contentKey="order.checkout.orderType">Order type</Translate>
                    </h2>
                    <div className="co-checkout-panel__body">
                        {this.renderDeliveryTypes()}
                    </div>
                </section>
            );
        }

        if (this.isDnaTableOrderContactOptional()) {
            form.push(
                this.renderCollapsibleCheckoutPanel({
                    stateKey: 'checkoutContactPanelOpen',
                    buttonId: 'co-checkout-contact-heading',
                    bodyId: 'co-checkout-contact-body',
                    contentKey: 'order.checkout.contact',
                    fallback: 'Contact',
                    children: this.renderUserInfo()
                })
            );
        } else {
            form.push(
                <section className="co-checkout-panel" aria-labelledby="co-checkout-user-heading">
                    <h2 id="co-checkout-user-heading" className="co-checkout-panel__head">
                        <Translate contentKey="order.checkout.contact">Contact</Translate>
                    </h2>
                    <div className="co-checkout-panel__body">{this.renderUserInfo()}</div>
                </section>
            );
        }

        if (this.state.order.orderType == "Collection") {
            form.push(this.renderOrderTime("Ready By"));
        }
        if ((GeneralUtils.isNullOrEmpty(this.state.order.scheduledForDelivery) || this.state.order.scheduledForDelivery == "true") && this.state.order.orderType == "Delivery") {

            form.push(this.renderOrderTime("Deliver By"));
        }

        if (this.state.order.orderType == "Table Order") {

            form.push(
                <section className="co-checkout-panel" aria-labelledby="co-checkout-table-number-heading">
                    <h2 id="co-checkout-table-number-heading" className="co-checkout-panel__head">
                        <Translate contentKey="order.checkout.tableNumberSection">Table number</Translate>
                    </h2>
                    <div className="co-checkout-panel__body">
                        <Row>
                            <Col md={12}>
                                <AvGroup>
                                    <Label for="tableBssId" className="sr-only">
                                        <Translate contentKey="order.checkout.tableNumberSection">Table number</Translate>
                                    </Label>
                                    <AvField
                                        id="tableBssId"
                                        type="select"
                                        name="tableBssId"
                                        disabled={false}
                                        value={this.state.order.tableBssId}
                                        onChange={this.__handleChangeOrder}>
                                        <option value="">Select…</option>
                                        {this.state.tables.map(element => (
                                            <option value={element.bssId} key={element.bssId}>
                                                {element.name}
                                            </option>))}
                                    </AvField>
                                </AvGroup>
                            </Col>
                        </Row>
                    </div>
                </section>
            )
        } else {
            if (this.state.order.orderType == "Delivery") {
                form.push(
                    this.renderCollapsibleCheckoutPanel({
                        stateKey: 'checkoutDeliveryAddressPanelOpen',
                        buttonId: 'co-checkout-delivery-address-heading',
                        bodyId: 'co-checkout-delivery-address-body',
                        contentKey: 'order.checkout.deliveryAddress',
                        fallback: 'Delivery Address',
                        children: this.addressListItem()
                    })
                );
            }
        }

        if (Number.isInteger(this.state.paymentOption) || this.state.paymentOption == "CARD" || this.state.paymentOption == "APPLE PAY" || this.state.paymentOption == "PAY PAL" || this.state.paymentOption == "WALLET") {
            form.push(
                this.renderCollapsibleCheckoutPanel({
                    stateKey: 'checkoutBillingAddressPanelOpen',
                    buttonId: 'co-checkout-billing-address-heading',
                    bodyId: 'co-checkout-billing-address-body',
                    contentKey: 'order.checkout.billingAddress',
                    fallback: 'Billing Address',
                    children: this.billingAddressListItem()
                })
            );
        }

        form.push(this.renderAllergiesAndNotes());
        return form;
    }

    renderAllergiesAndNotes() {
        let form = [];
        form.push(
            this.renderCollapsibleCheckoutPanel({
                stateKey: 'checkoutAllergiesPanelOpen',
                buttonId: 'co-checkout-allergies-heading',
                bodyId: 'co-checkout-allergies-body',
                contentKey: 'order.checkout.allergiesAndNotes',
                fallback: 'Allergies & Notes',
                children: (
                    <React.Fragment>
                        <InputTextarea value={this.state.order.orderNotes}
                                       style={{borderRadius: "5px", width: "-webkit-fill-available"}}
                                       name="orderNotes"
                                       placeholder="Leave a note for the store with anything they need to know"
                                       disabled={this.state.viewMode}
                                       rows={2} cols={50}
                                       maxLength={100}
                                       onChange={this.__handleChangeOrder}/>
                        <p></p>

                        <InputTextarea value={this.state.order.allergies}
                                       style={{borderRadius: "5px", width: "-webkit-fill-available"}}
                                       name="allergies"
                                       placeholder="Allergies"
                                       disabled={this.state.viewMode}
                                       rows={2} cols={50}
                                       maxLength={100}
                                       onChange={this.__handleChangeOrder}/>
                        <p></p>
                        <div>
                            <Row>
                                <Col md="12">
                                    <AvGroup>
                                        <Checkbox onChange={(e) => this.setChecked("saveAllergies", e.checked)}
                                                  name="saveAllergies"
                                                  value={this.state.order.saveAllergies}
                                                  checked={this.state.order.saveAllergies}></Checkbox>

                                        <Label for="firstName">
                                            <Translate contentKey="saveAllergies">&nbsp;&nbsp;Save my allergies for future
                                                orders</Translate>

                                        </Label>
                                    </AvGroup>
                                </Col>
                            </Row>
                        </div>
                    </React.Fragment>
                )
            })
        );
        return form;

    }

    billingAddressListItem() {
        let form = [];

        form.push(<Row>
            {this.state.order.orderType == "Delivery" && <Col md="12">
                <AvGroup>
                    <Checkbox onChange={(e) => this.setSameDeliveryAddress("sameAsDeliveryAddress", e.checked)}
                              name="sameAsDeliveryAddress"
                              value={this.state.sameAsDeliveryAddress}
                              checked={this.state.sameAsDeliveryAddress}></Checkbox>

                    <Label for="firstName">
                        <Translate contentKey="sameAsDeliveryAddress">&nbsp;&nbsp;Same as my delivery
                            address</Translate>

                    </Label>
                </AvGroup>
            </Col>}
            {this.state.sameAsDeliveryAddress == false && <Col md="12">
                    <Label for="mobilePhone">
                        <Translate contentKey="contactManagement.mobilePhone">&nbsp;&nbsp;My Billing
                            Addresses</Translate>
                    </Label>

                    <AvField
                        type="select"
                        disabled={false}
                        className="form-control"
                        name="billingAddressOption"
                        value={this.state.billingAddressOption}
                        onChange={(e) => {
                            let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                            this.setState({
                                billingAddressOption: value,
                                memberBillingAddress: this.getBillingAddressDetailById(value)
                            });
                            if (GeneralUtils.isNullOrEmpty(value)) {
                                this.setState({
                                    showBillingAddressDetails: false,
                                });
                            }
                            if (value == "Other") {
                                this.setState({
                                    showBillingAddressDetails: true,
                                });
                            }
                        }}>

                        {this.state.billingAddressList.map(element => (<option value={element.id} key={element.id}>
                            {element.description}
                        </option>))}
                    </AvField>
            </Col>}

        </Row>);

        if (this.state.sameAsDeliveryAddress == false && !GeneralUtils.isNullOrEmpty(this.state.billingAddressOption) && this.state.billingAddressOption != "Other") {
            form.push(<Row className="mt-2" key="billing-address-details-btn">
                <Col md="12">
                    <Button color="outline-primary" disabled={false}
                            style={{width: '100%', border: "0"}}
                            onClick={() => {

                                this.setState({
                                    showBillingAddressDetails: true,
                                });

                            }}>
                        <Translate contentKey="entity.action.add">Address Details</Translate>
                    </Button>
                </Col>
            </Row>);
        }

        if (this.state.sameAsDeliveryAddress == false) {
            form.push(this.renderNewBillingAddress());
        }

        return form;
    }

    addressListItem() {
        let form = [];


        form.push(<Row key="delivery-address-select-row">
            <Col md="12">
                <Label for="mobilePhone">
                    <Translate contentKey="contactManagement.mobilePhone">&nbsp;&nbsp;My Delivery Addresses</Translate>
                </Label>

                <AvField
                    type="select"
                    disabled={false}
                    className="form-control"
                    name="addressOption"
                    value={this.state.addressOption}
                    onChange={(e) => {
                        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                        this.setState({
                            addressOption: value, memberUserAddress: this.getAddressDetailById(value)
                        });
                        if (GeneralUtils.isNullOrEmpty(value)) {
                            this.setState({
                                showDeliveryAddressDetails: false,
                            });
                        }
                        if (value == "Other") {
                            this.setState({
                                showDeliveryAddressDetails: true,
                            });
                        }
                    }}>

                    {this.state.addressList.map(element => (<option value={element.id} key={element.id}>
                        {element.description}
                    </option>))}
                </AvField>
            </Col>
        </Row>);

        if (!GeneralUtils.isNullOrEmpty(this.state.addressOption) && this.state.addressOption != "Other") {
            form.push(<Row className="mt-2" key="delivery-address-details-btn">
                <Col md="12">
                    <Button color="outline-primary" disabled={false}
                            style={{width: '100%', border: "0"}}
                            onClick={() => {

                                this.setState({
                                    showDeliveryAddressDetails: true,
                                });

                            }}>
                        <Translate contentKey="entity.action.add">Address Details</Translate>
                    </Button>
                </Col>
            </Row>);
        }


        form.push(this.renderNewAddress())

        return form;
    }

    async reloadPage(message) {
        if (!GeneralUtils.isNullOrEmpty(message)) {
            clearOrderBasketStorage();
        }

        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("merchantBranchId")) && localStorage.getItem("merchantBranchId") != -1) {
            const branchId = localStorage.getItem("merchantBranchId");
            const storeInfoTimeoutMs = 15000;
            let response;
            try {
                response = await Promise.race([
                    this.merchantBranchService.getStoreInfo(branchId),
                    new Promise((_, reject) => setTimeout(() => reject(new Error("getStoreInfo timeout")), storeInfoTimeoutMs))
                ]);
            } catch (e) {
                response = null;
            }
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && !GeneralUtils.isNullOrEmpty(response.domainName)) {
                if (GeneralUtils.isServedInWebMarketUrl()) {
                    this.setState({
                        loading: false,
                    });
                    window.location.href = response.domainName + message;
                } else {
                    this.setState({
                        loading: false,
                    });
                    window.location.href = window.location.href.replace("/approveOrder", "").replace("/confirmOrder", "") + message;
                }

            } else {
                this.setState({
                    loading: false,
                });
                window.location.href = message;
            }
        } else {
            this.setState({
                loading: false,
            });
            window.location.href = message;
        }
    }

    checkValidations() {
        let orderData = this.refOrderCheckout.getData();
        if (orderData.checkOutItemList.length == 0) {
            return "Your order is empty!";
        }
        if (GeneralUtils.isNullOrEmpty(this.state.order.orderType)) {
            return "Please select an order type!";
        }
        if (this.state.order.orderType == "Delivery") {
            if (GeneralUtils.isNullOrEmpty(this.state.addressOption)) {
                return "Please select an address";
            } else if (GeneralUtils.isNullOrEmpty(this.state.memberUserAddress.postCode) || GeneralUtils.isNullOrEmpty(this.state.memberUserAddress.addressLine1) || GeneralUtils.isNullOrEmpty(this.state.memberUserAddress.city)) {
                return "Please fill the address details";
            }
            if (!GeneralUtils.isNullOrEmpty(this.state.minimumDeliveryBasketPrice) && this.refOrderCheckout.getData().totalPrice < this.state.minimumDeliveryBasketPrice) {
                return "Your basket total is under minimum basket total";
            }

        }

        if (this.state.order.orderType == "Table Order" && GeneralUtils.isNullOrEmpty(this.state.order.tableBssId)) {
            return "Please select Table number";
        }
        if (!this.isDnaTableOrderContactOptional() && GeneralUtils.isNullOrEmpty(this.state.memberUserAddress.mobilePhone)) {
            return "Please fill the mobile phone";
        }

        if (GeneralUtils.isNullOrEmpty(this.state.paymentOption)) {
            return "Please select payment type";
        }

        if (this.state.sameAsDeliveryAddress == false && (Number.isInteger(this.state.paymentOption) || this.state.paymentOption == "CARD" || this.state.paymentOption == "APPLE PAY" || this.state.paymentOption == "PAY PAL" || this.state.paymentOption == "WALLET") && (this.state.order.provider == "DOJO" || this.state.order.provider == "OPAYO" || this.state.order.provider == "ELAVON")) {
            if (GeneralUtils.isNullOrEmpty(this.state.memberBillingAddress.postCode) || GeneralUtils.isNullOrEmpty(this.state.memberBillingAddress.addressLine1) || GeneralUtils.isNullOrEmpty(this.state.memberBillingAddress.city)) {
                return "Please fill the billing address details";
            }
        }

    }

    /**
     * Basket /place ve /prepare için aynı gövde (confirmOrder ile senkron tutun).
     * @param {object} opts
     * @param {*} [opts.applePayment]
     * @param {*} [opts.elavonHostedCardHref]
     * @param {*} [opts.paymentAccessToken] — verilirse state.accessToken yerine bu kullanılır; DNA hazırlık için null gönderin.
     */
    buildBasketPlacePayload(opts) {
        opts = opts || {};
        let orderData = this.refOrderCheckout.getData();
        let cardId = opts.elavonHostedCardHref != null ? opts.elavonHostedCardHref : this.state.cardIdentifier;
        const payTok = opts.paymentAccessToken !== undefined ? opts.paymentAccessToken : this.state.accessToken;
        const snap = opts.dnaSaveCardSnapshot != null ? opts.dnaSaveCardSnapshot : this.state.dnaSaveCardSnapshot;
        const allowSaveCard = this.state.order.provider === "DNA" && (this.state.paymentOption == "CARD" || this.state.paymentOption == "WALLET");
        const saveDna = allowSaveCard && this.state.order.saveCard;
        return {
            basketDetailList: orderData.checkOutItemList,
            orderNotes: this.state.order.orderNotes,
            allergies: this.state.order.allergies,
            orderType: this.state.order.orderType,
            orderTimeForDelivery: this.state.order.orderTimeForDelivery,
            tableBssId: this.state.order.orderType == "Table Order" ? this.state.order.tableBssId : null,
            memberUserAddress: this.state.memberUserAddress,
            memberBillingAddress: (() => {
                const isCardLikePayment = Number.isInteger(this.state.paymentOption) || this.state.paymentOption == "CARD" || this.state.paymentOption == "APPLE PAY" || this.state.paymentOption == "PAY PAL" || this.state.paymentOption == "WALLET";
                if (!isCardLikePayment) {
                    return null;
                }
                return this.state.sameAsDeliveryAddress == true ? this.state.memberUserAddress : this.state.memberBillingAddress;
            })(),
            id: orderData.id,
            saveCard: allowSaveCard ? this.state.order.saveCard : false,
            cardExpireDate: (allowSaveCard && this._elavonCardExpireDate && this.state.paymentOption === "CARD" && this.state.order.saveCard) ? this._elavonCardExpireDate : null,
            paymentAccessToken: payTok,
            cardIdentifier: cardId,
            dnaMerchantTokenId: saveDna && snap && snap.dnaMerchantTokenId ? snap.dnaMerchantTokenId : null,
            dnaPanStar: saveDna && snap && snap.dnaPanStar ? snap.dnaPanStar : null,
            dnaCardSchemeId: saveDna && snap && snap.dnaCardSchemeId ? snap.dnaCardSchemeId : null,
            dnaCardSchemeName: saveDna && snap && snap.dnaCardSchemeName ? snap.dnaCardSchemeName : null,
            dnaTokenExpiryDisplay: saveDna && snap && snap.dnaTokenExpiryDisplay ? snap.dnaTokenExpiryDisplay : null,
            // Only map Elavon card flows to CARD; keep PAY AT COUNTER / PAYPAL / APPLE PAY as-is.
            paymentType: (this.state.order.provider === "ELAVON"
                && (this.state.paymentOption === "CARD" || this.state.paymentOption === "WALLET" || Number.isInteger(this.state.paymentOption)))
                ? "CARD"
                : (Number.isInteger(this.state.paymentOption) ? "CARD" : this.state.paymentOption),
            cardNumber: Number.isInteger(this.state.paymentOption) ? this.state.paymentOption : null,
            website: GeneralUtils.getUiUrl(),
            notificationURL: SERVER_URL,
            applePayPayment: opts.applePayment
        };
    }

    confirmOrder = (session, applePayment, elavonHostedCardHref) => {
        if (this.refOrderCheckout != null) {
            var validations = this.checkValidations();
            if (GeneralUtils.isNullOrEmpty(validations)) {
                let data = this.buildBasketPlacePayload({
                    applePayment,
                    elavonHostedCardHref
                });
                if (this.state.order.provider === "ELAVON" && this.state.elavonOrderHref) {
                    data.elavonOrderHref = this.state.elavonOrderHref;
                    if (this.state.elavonPaymentSessionHref) data.elavonPaymentSessionHref = this.state.elavonPaymentSessionHref;
                }

                this.setState({loading: true, confirmButtonDisabled: true, confirmButtonName: 'Please Wait'});

                this.basketService.placeOrder(data).then((response) => {
                    const isCardLikePayment = Number.isInteger(this.state.paymentOption)
                        || this.state.paymentOption === "CARD"
                        || this.state.paymentOption === "WALLET"
                        || this.state.paymentOption === "APPLE PAY";
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        if (!GeneralUtils.isNullOrEmpty(response.acsUrl)) {
                            if (this.state.paymentOption === "APPLE PAY" && session) {
                                GeneralUtils.completeApplePayPayment(session, true);
                            }
                            this.setState({
                                loading: false,
                                applePaySheetOpen: false,
                                confirmButtonDisabled: false,
                                confirmButtonName: 'Confirm Order'
                            });
                            this.opoyaThreeDSecurePostPage(response);
                        } else if (!GeneralUtils.isNullOrEmpty(response.redirectUrl)) {
                            if (this.state.paymentOption === "APPLE PAY" && session) {
                                GeneralUtils.completeApplePayPayment(session, true);
                            }
                            this.setState({
                                loading: false,
                                applePaySheetOpen: false,
                                confirmButtonDisabled: false,
                                confirmButtonName: 'Confirm Order'
                            });
                            window.location.href = response.redirectUrl;
                        } else if (isCardLikePayment && response.paymentSuccess === false) {
                            if (this.state.paymentOption === "APPLE PAY" && session) {
                                GeneralUtils.completeApplePayPayment(session, false);
                            }
                            this.setState({
                                loading: false,
                                applePaySheetOpen: false,
                                paymentOption: null,
                                confirmButtonDisabled: false,
                                confirmButtonName: 'Confirm Order'
                            });
                            toast.warn(response.errorMessage || response.message || "Payment could not be completed. Please try again.");
                            return;
                        } else {
                            this._applePaySession = null;
                            this.clearApplePayDismissFallback();

                            if (this.state.memberUserAddress.saveAddress) {
                                this.memberUserAddressService.createWithoutNotification(this.state.memberUserAddress).then((response) => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                    }
                                });
                            }

                            if (this.state.memberBillingAddress.saveBillingAddress) {
                                this.memberBillingAddressService.createWithoutNotification(this.state.memberBillingAddress).then((response) => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                    }
                                });
                            }

                            if (this.state.order.saveAllergies) {
                                this.memberUserNotesService.updateWithoutNotification(null, this.state.order.allergies).then((response) => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                    }
                                });
                            }
                            if (this.state.paymentOption === "APPLE PAY" && session) {
                                GeneralUtils.completeApplePayPayment(session, true);
                            }

                            this.handleOrderPlacedSuccess(response);
                        }

                    } else {
                        if (response && response.type) {
                            if (response.message == "Your order is empty!") {
                                this.getBasketInfo(this.state.order.orderType);
                            }
                            GeneralUtils.showNotification(response);
                        } else if (!response) {
                            toast.warn("Order could not be completed. Check your connection and try again.");
                        }
                        if (this.state.paymentOption === "APPLE PAY" && session) {
                            GeneralUtils.completeApplePayPayment(session, false);
                        }
                        this._applePaySession = null;
                        this.clearApplePayDismissFallback();
                        this.setState({
                            loading: false,
                            applePaySheetOpen: false,
                            paymentOption: null,
                            confirmButtonDisabled: false,
                            confirmButtonName: 'Confirm Order'
                        });
                    }
                }).catch(() => {
                    if (this.state.paymentOption === "APPLE PAY" && session) {
                        GeneralUtils.completeApplePayPayment(session, false);
                    }
                    this._applePaySession = null;
                    this.clearApplePayDismissFallback();
                    this.setState({
                        loading: false,
                        applePaySheetOpen: false,
                        paymentOption: null,
                        confirmButtonDisabled: false,
                        confirmButtonName: 'Confirm Order'
                    });
                    toast.warn("Order could not be completed. Please try again.");
                });


                localStorage.removeItem("tableBssId");
            } else {
                if (this.state.paymentOption === "APPLE PAY" && session) {
                    GeneralUtils.completeApplePayPayment(session, false);
                }
                this._applePaySession = null;
                this.clearApplePayDismissFallback();
                this.setState({
                    loading: false,
                    applePaySheetOpen: false,
                    confirmButtonDisabled: false,
                    confirmButtonName: 'Confirm Order'
                });
                return toast.warn(validations);
            }
        }


    }

    async opoyaThreeDSecurePostPage(response) {
        const form = document.createElement('form');
        form.method = "post";
        form.action = response.acsUrl;
        const hiddenField = document.createElement('input');
        hiddenField.type = "hidden";
        hiddenField.name = "creq";
        hiddenField.value = response.creq;
        form.appendChild(hiddenField);
        const hiddenField1 = document.createElement('input');
        hiddenField1.type = "hidden";
        hiddenField1.name = "threeDSSessionData";
        hiddenField1.value = response.transactionId;
        form.appendChild(hiddenField1);
        document.body.appendChild(form);
        form.submit();
    }

    waitForOpayoContainer = (selector, timeoutMs = 3000, pollMs = 50) => new Promise((resolve) => {
        const start = Date.now();
        const check = () => {
            if (document.querySelector(selector)) {
                resolve(true);
                return;
            }
            if (Date.now() - start >= timeoutMs) {
                resolve(false);
                return;
            }
            setTimeout(check, pollMs);
        };
        check();
    });

    async renderOpayoFrame(merchantSessionKey, crossReference, cardId) {
        if (this.state.connectE != undefined && this.state.connectE != null) {
            this.state.connectE.destroy();
        }

        const containerSelector = GeneralUtils.isNullOrEmpty(crossReference)
            ? '#card-payment'
            : '#cvv-payment' + cardId;
        const containerReady = await this.waitForOpayoContainer(containerSelector);
        if (!containerReady) {
            console.warn('Opayo checkout container not found:', containerSelector);
            return;
        }

        if (GeneralUtils.isNullOrEmpty(crossReference)) {
            this.setState({
                cardIdentifier: null, accessToken: merchantSessionKey, connectE: new window.sagepayCheckout({
                    containerSelector: containerSelector,
                    merchantSessionKey: merchantSessionKey,
                    onTokenise: this.onTokeniseOpayo
                })
            });
        } else {
            this.setState({
                cardIdentifier: crossReference, accessToken: merchantSessionKey, connectE: new window.sagepayCheckout({
                    containerSelector: containerSelector,
                    reusableCardIdentifier: crossReference,
                    merchantSessionKey: merchantSessionKey,
                    onTokenise: this.onTokeniseOpayo
                })
            });
        }

    }

    setCardIdentifier = (cardIdentifier) => {
        if (!GeneralUtils.isNullOrEmpty(cardIdentifier)) {
            this.setState({
                cardIdentifier: cardIdentifier,
            });
        }

        this.confirmOrder();
    }

    onTokeniseOpayo = (response) => {
        if (response.success) {
            this.setCardIdentifier(response.cardIdentifier);
        }
    }

    resetApplePayCheckoutUi() {
        this._applePaySession = null;
        this._applePayPaymentAuthorized = false;
        this.clearApplePayDismissFallback();
        this.setState({
            loading: false,
            applePaySheetOpen: false,
            confirmButtonDisabled: false,
            confirmButtonName: 'Confirm Order'
        });
    }

    clearApplePayDismissFallback() {
        if (this._applePayDismissFallbackTimer) {
            clearTimeout(this._applePayDismissFallbackTimer);
            this._applePayDismissFallbackTimer = null;
        }
        if (this._applePayDismissFallbackHandler) {
            document.removeEventListener('visibilitychange', this._applePayDismissFallbackHandler);
            this._applePayDismissFallbackHandler = null;
        }
    }

    installApplePayDismissFallback(session) {
        this.clearApplePayDismissFallback();
        const that = this;
        const scheduleResetIfDismissed = function () {
            if (that._applePayDismissFallbackTimer) {
                clearTimeout(that._applePayDismissFallbackTimer);
            }
            that._applePayDismissFallbackTimer = setTimeout(function () {
                if (that._applePaySession !== session || that._applePayPaymentAuthorized) {
                    return;
                }
                GeneralUtils.abortApplePaySession(session);
                that.resetApplePayCheckoutUi();
            }, 400);
        };
        this._applePayDismissFallbackHandler = function () {
            if (document.visibilityState === 'visible') {
                scheduleResetIfDismissed();
            }
        };
        document.addEventListener('visibilitychange', this._applePayDismissFallbackHandler);
    }

    tokeniseApplePay() {
        if (window.ApplePaySession) {
            const payreq = {
                countryCode: 'GB', currencyCode: 'GBP', total: {
                    label: 'Total Cost', amount: this.refOrderCheckout.getData().totalPrice.toFixed(2),
                }, supportedNetworks: ['amex', 'masterCard', 'visa'], merchantCapabilities: ['supports3DS'],
            };
            const appleSession = window.ApplePaySession;
            const session = new appleSession(6, payreq)
            let that = this;
            this._applePaySession = session;
            this._applePayPaymentAuthorized = false;
            this.setState({applePaySheetOpen: true, confirmButtonDisabled: true});
            this.installApplePayDismissFallback(session);
            session.onvalidatemerchant = async function (event) {
                try {
                    const orderData = that.refOrderCheckout && that.refOrderCheckout.getData ? that.refOrderCheckout.getData() : null;
                    const response = (await that.paymentService.createApplePayToken(localStorage.getItem("merchantBranchId"), {
                        validationUrl: event && event.validationURL ? event.validationURL : null,
                        amount: orderData && orderData.totalPrice != null ? Number(orderData.totalPrice).toFixed(2) : null,
                        currency: 'GBP',
                        invoiceId: orderData && orderData.id != null ? String(orderData.id) : null,
                        displayName: GeneralUtils.getMemberPaymentDisplayName(
                            that.state && that.state.order ? that.state.order.tradingName : null
                        ),
                        provider: that.state && that.state.order ? that.state.order.provider : null
                    }));
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        session.completeMerchantValidation(response)
                    } else {
                        GeneralUtils.abortApplePaySession(session);
                        that.resetApplePayCheckoutUi();
                        toast.warn("Apple Pay merchant validation failed.");
                    }

                } catch (error) {
                    GeneralUtils.abortApplePaySession(session);
                    that.resetApplePayCheckoutUi();
                    toast.warn(error && error.message ? error.message : "Apple Pay token creation failed.");
                }

            }
            session.onpaymentauthorized = async function (event) {
                that._applePayPaymentAuthorized = true;
                that.clearApplePayDismissFallback();
                that.confirmOrder(session, event.payment);
            }
            session.oncancel = function (event) {
                that.resetApplePayCheckoutUi();
            };
            session.begin()
        } else {
            this.resetApplePayCheckoutUi();
            toast.warn("Apple Pay is not supported on this device/browser.");
        }
    }

    getOpayoPayment() {
        this.state.connectE.tokenise();
    }

    waitForElavonHostedFieldsReady = async (timeoutMs = 5000, pollMs = 200) => {
        const start = Date.now();
        while (!window.ElavonHostedFields && (Date.now() - start) < timeoutMs) {
            await new Promise(resolve => setTimeout(resolve, pollMs));
        }
        return !!window.ElavonHostedFields;
    };

    async getElavonPayment() {
        // Script loading is async; make sure hosted fields are actually ready.
        if (!this.elavonHostedFields || !this.elavonFieldTypes) {
            const ready = await this.waitForElavonHostedFieldsReady();
            if (ready && !this.elavonHostedFields && !GeneralUtils.isNullOrEmpty(this.state.accessToken)) {
                // Re-initialise using current payment session id.
                this.initialiseElavonHostedFields({ id: this.state.accessToken });
            }
        }
        if (!this.elavonHostedFields || !this.elavonFieldTypes) {
            this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
            toast.warn("Please wait for the card fields to load.");
            return;
        }
        const fieldTypes = this.elavonFieldTypes;
        const state = this.elavonHostedFields.getState();
        const isSavedCard = Number.isInteger(this.state.paymentOption);
        // Saved card flow'da card alanları (hosted fields) invalid görünebilir,
        // bu yüzden submit'i engellemiyoruz; 3DS challenge payment session üzerinden yapılacak.
        if (!isSavedCard && !state.isValid) {
            if (!state.fields.cardholderName.isValid) {
                this.elavonHostedFields.addClass(fieldTypes.cardholderName, 'field-error');
            }
            if (!state.fields.cardNumber.isValid) {
                this.elavonHostedFields.addClass(fieldTypes.cardNumber, 'field-error');
            }
            if (!state.fields.cardExpirationDate.isValid) {
                this.elavonHostedFields.addClass(fieldTypes.cardExpirationDate, 'field-error');
            }
            if (!state.fields.cardCvv.isValid) {
                this.elavonHostedFields.addClass(fieldTypes.cardCvv, 'field-error');
            }
            this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
            toast.warn("Please check your card details.");
            return;
        }
        const expField = state.fields && state.fields.cardExpirationDate;
        this._elavonCardExpireDate = (expField && (expField.value || expField.displayValue || (expField.value === 0 ? '0' : null))) || null;
        this.setState({loading: true, confirmButtonDisabled: true, confirmButtonName: 'Please Wait'});
        const billToAddr = this.state.sameAsDeliveryAddress ? this.state.memberUserAddress : this.state.memberBillingAddress;
        const shipToAddr = this.state.memberUserAddress;
        const email = (shipToAddr && shipToAddr.email) || (billToAddr && billToAddr.email) || '';
        this.elavonHostedFields.submit({
            billTo: {
                street1: (billToAddr && billToAddr.addressLine1) || '',
                city: (billToAddr && billToAddr.city) || '',
                postalCode: (billToAddr && billToAddr.postCode) || '',
            },
            shipTo: {
                street1: (shipToAddr && shipToAddr.addressLine1) || '',
                city: (shipToAddr && shipToAddr.city) || '',
                postalCode: (shipToAddr && shipToAddr.postCode) || '',
            },
            shopperEmailAddress: email,
        });
    }

    getDOJOPayment() {
        this.setState({
            confirmButtonDisabled: true, confirmButtonName: 'Please Wait'
        });
        var extraInfo = {
            savePaymentMethod: this.state.order.saveCard
        };

        let that = this;
        this.state.connectE.executePayment(extraInfo).then(function (data) {
            if (data.statusCode == 99) {
                that.confirmOrder()
            } else {
                that.setState({
                    loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
                });
                if (!GeneralUtils.isNullOrEmpty(data.message)) {
                    toast.warn(data.message);
                } else if (data.statusCode == 5) {
                    that.removeCardIframes();
                    that.createAccessTokenForDojo(that.state.crossReference, that.state.paymentType);
                } else {
                    toast.warn("An unexpected error has occurred.");
                }

            }


        }).catch(function (data) {
            that.setState({
                loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'
            });

            if (data.statusCode == 401) {
                window.location.reload();

            } else {
                if (!GeneralUtils.isNullOrEmpty(data.message)) {
                    toast.warn(data.message);
                }
            }
        });
    }

    async onClickConfirmOrderButton() {
        if (this.state.confirmButtonDisabled) {
            return;
        }
        var validations = this.checkValidations();
        if (GeneralUtils.isNullOrEmpty(validations)) {
            const isApplePayCheckout = (this.state.order.provider == "OPAYO" || this.state.order.provider == "ELAVON" || this.state.order.provider == "DNA")
                && this.state.paymentOption == "APPLE PAY";
            // Apple Pay: no loading overlay — it steals touches and dismisses the native sheet.
            if (!isApplePayCheckout) {
                this.setState({loading: true, confirmButtonDisabled: true, confirmButtonName: 'Please Wait'});
            }
            if (this.state.order.provider == "DOJO" && (this.state.paymentOption == "CARD" || this.state.paymentOption == "WALLET" || Number.isInteger(this.state.paymentOption))) {
                this.getDOJOPayment();
            } else if (this.state.order.provider == "OPAYO" && (this.state.paymentOption == "CARD" || Number.isInteger(this.state.paymentOption))) {
                this.getOpayoPayment();
            } else if (this.state.order.provider == "DNA" && (
                this.state.paymentOption == "CARD" || this.state.paymentOption == "WALLET" || Number.isInteger(this.state.paymentOption)
            )) {
                // DNA Hosted Fields: submit payment on client, then place order with transaction reference.
               if (GeneralUtils.isNullOrEmpty(this.dnaHostedFields) || typeof this.dnaHostedFields.submit !== "function") {
                    await this.createAccessTokenForDna();
                }
                if (GeneralUtils.isNullOrEmpty(this.dnaHostedFields) || typeof this.dnaHostedFields.submit !== "function") {
                    this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                    return toast.warn("Please wait for the card fields to load.");
                }

                const orderData = this.refOrderCheckout != null ? this.refOrderCheckout.getData() : null;
                const dnaAmountMajor = GeneralUtils.parseDnaAmountMajorUnits(orderData && orderData.totalPrice);
                if (dnaAmountMajor == null) {
                    this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                    return toast.warn("Please wait until basket total is ready.");
                }

                const baseUi = (typeof window !== "undefined" && window.location)
                    ? (window.location.origin + window.location.pathname)
                        .replace(/\/approveOrder(?:\/)?$/i, "")
                        .replace(/\/confirmOrder(?:\/)?$/i, "")
                    : GeneralUtils.getUiUrl().replace("/approveOrder", "").replace("/confirmOrder", "");

                const dnaReturns = GeneralUtils.getDnaHostedFieldsReturnUrls(
                    baseUi,
                    "approveOrder?dnaReturn=1",
                    "approveOrder?dnaFail=1",
                    { dnaTestMode: GeneralUtils.isDnaHostedFieldsTestMode() }
                );
                const dnaWebhookBase = getDnaWebhookServerBase();
                const basketIdForDna = orderData && orderData.id ? String(orderData.id) : "";
                const dnaWebhookUrl = dnaWebhookBase + "/dispatchio/dna/webhook"
                    + (basketIdForDna ? ("/" + encodeURIComponent(basketIdForDna)) : "");

                const savePaymentMethod = (this.state.paymentOption == "CARD" || this.state.paymentOption == "WALLET") && this.state.order.saveCard;

                const paymentData = {
                    currency: 'GBP',
                    description: orderData && !GeneralUtils.isNullOrEmpty(orderData.orderNo) ? ("Order " + orderData.orderNo) : 'Order',
                    // PRE-AUTH: blokaj; tahsilat sunucuda capture ile (PaymentService.performPayment).
                    transactionType: 'PRE-AUTH',
                    savePaymentMethod,
                    paymentSettings: {
                        terminalId: this.state.dnaTerminalId,
                        returnUrl: dnaReturns.returnUrl,
                        failureReturnUrl: dnaReturns.failureReturnUrl,
                        callbackUrl: dnaWebhookUrl,
                        failureCallbackUrl: dnaWebhookUrl
                    },
                    invoiceId: orderData && orderData.id ? String(orderData.id) : (orderData && orderData.orderNo ? String(orderData.orderNo) : "order"),
                    amount: dnaAmountMajor,
                    deliveryType: 'service',
                    customerDetails: {
                        email: (this.state.memberUserAddress && this.state.memberUserAddress.email) ? this.state.memberUserAddress.email : undefined,
                        firstName: this.state.memberBillingAddress && this.state.memberBillingAddress.firstName ? this.state.memberBillingAddress.firstName : undefined,
                        lastName: this.state.memberBillingAddress && this.state.memberBillingAddress.lastName ? this.state.memberBillingAddress.lastName : undefined,
                        mobilePhone: this.state.memberUserAddress && this.state.memberUserAddress.mobilePhone ? this.state.memberUserAddress.mobilePhone.replace(/^0/, "44-") : undefined,
                        accountDetails: {
                            accountId: (this.state.memberUserAddress && this.state.memberUserAddress.email) ? this.state.memberUserAddress.email : undefined
                        },
                        billingAddress: {
                            firstName: this.state.memberBillingAddress && this.state.memberBillingAddress.firstName ? this.state.memberBillingAddress.firstName : undefined,
                            lastName: this.state.memberBillingAddress && this.state.memberBillingAddress.lastName ? this.state.memberBillingAddress.lastName : undefined,
                            addressLine1: this.state.memberBillingAddress && this.state.memberBillingAddress.addressLine1 ? this.state.memberBillingAddress.addressLine1 : undefined,
                            postalCode: this.state.memberBillingAddress && this.state.memberBillingAddress.postCode ? this.state.memberBillingAddress.postCode : undefined,
                            city: this.state.memberBillingAddress && this.state.memberBillingAddress.city ? this.state.memberBillingAddress.city : undefined,
                            country: 'GB'
                        },
                        deliveryDetails: {
                            deliveryTimeFrame: '01',
                            deliveryAddress: {
                                firstName: this.state.memberUserAddress && this.state.memberUserAddress.firstName ? this.state.memberUserAddress.firstName : undefined,
                                lastName: this.state.memberUserAddress && this.state.memberUserAddress.lastName ? this.state.memberUserAddress.lastName : undefined,
                                addressLine1: this.state.memberUserAddress && this.state.memberUserAddress.addressLine1 ? this.state.memberUserAddress.addressLine1 : undefined,
                                postalCode: this.state.memberUserAddress && this.state.memberUserAddress.postCode ? this.state.memberUserAddress.postCode : undefined,
                                city: this.state.memberUserAddress && this.state.memberUserAddress.city ? this.state.memberUserAddress.city : undefined,
                                phone: this.state.memberUserAddress && this.state.memberUserAddress.mobilePhone ? this.state.memberUserAddress.mobilePhone.replace(/^0/, "44-") : undefined,
                                country: 'GB'
                            }
                        }
                    }
                };

                try {
                    // Server-side checks (stock, postcode, min basket, etc.) without charging — same as start of placeOrder.
                    // Reduces "paid on DNA but placeOrder failed" when validation would have failed before payment.
                    const prepareDraft = this.buildBasketPlacePayload({ paymentAccessToken: null });
                    const prepared = await this.basketService.prepareOrder(prepareDraft);
                    if (GeneralUtils.isNullOrEmpty(prepared)) {
                        this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                        return toast.warn("Could not validate your order. Please try again.");
                    }
                    if (!GeneralUtils.isNullOrEmpty(prepared.type)) {
                        this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                        return toast.warn(prepared.message || "Your order could not be confirmed. Please review your details.");
                    }

                    try { console.debug("DNA hosted-fields submit payload:", paymentData); } catch (e) { /* ignore */ }
                    const dnaSubmitTimeoutMs = 45000;
                    const res = await Promise.race([
                        this.dnaHostedFields.submit({ paymentData }),
                        new Promise((_, reject) => setTimeout(() => reject({
                            code: "DNA_SUBMIT_TIMEOUT",
                            message: "Card authorisation timed out. Please try again."
                        }), dnaSubmitTimeoutMs))
                    ]);
                    GeneralUtils.logDnaHostedFieldsPreCaptureState(res);
                    try { console.debug("DNA hosted-fields submit response:", res); } catch (e) { /* ignore */ }
                    if (!GeneralUtils.isDnaHostedFieldsSuccess(res)) {
                        const u = GeneralUtils.unwrapDnaHostedFieldsSubmitResponse(res);
                        this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                        return toast.warn((u && u.message) || (res && res.message) || "Card authorisation was not approved.");
                    }
                    const txRef = GeneralUtils.extractDnaHostedFieldsTransactionRef(res);
                    if (GeneralUtils.isNullOrEmpty(txRef)) {
                        this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                        return toast.warn("No transaction reference from payment provider. Please try again.");
                    }
                    const walletSnap = savePaymentMethod ? GeneralUtils.extractDnaTokenWalletSaveFields(res) : null;
                    // setState is async: placeOrder must see the DNA transaction id in paymentAccessToken, not the old OAuth token.
                    this.setState({ accessToken: txRef, dnaSaveCardSnapshot: walletSnap }, () => this.confirmOrder());
                    return;
                } catch (err) {
                    try {
                        console.warn("DNA hosted-fields submit error:", err);
                        console.warn("DNA hosted-fields submit error details:", {
                            name: err && err.name,
                            code: err && err.code,
                            message: err && err.message,
                            stack: err && err.stack,
                            keys: err ? Object.keys(err) : [],
                            raw: err
                        });
                    } catch (e) { /* ignore */ }
                    this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                    if (err && err.code === 'DNA_SUBMIT_TIMEOUT') return toast.warn(err.message || "Card authorisation timed out. Please try again.");
                    if (err && err.code === 'INVALID_CARD_DATA') return toast.warn("Invalid card data.");
                    if (err && err.code === 'THREE_D_SECURE_ERROR') return toast.warn("3D Secure error.");
                    if (err && err.message) return toast.warn(err.message);
                    return toast.warn("Card payment failed. Please try again.");
                }
            } else if (this.state.order.provider == "ELAVON" && this.state.paymentOption == "CARD") {
                // New card (hostedPaymentFields): ensure we have a valid total and a payment session.
                // If totals are not ready yet, token creation may be skipped and hosted-fields submit can't work.
                if (this.refOrderCheckout != null) {
                    const orderData = this.refOrderCheckout.getData();
                    const totalPrice = orderData && !GeneralUtils.isNullOrEmpty(orderData.totalPrice) ? Number(orderData.totalPrice) : null;
                    if (totalPrice == null || isNaN(totalPrice) || totalPrice <= 0) {
                        this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                        return toast.warn("Please wait until basket total is ready.");
                    }
                }

                if (GeneralUtils.isNullOrEmpty(this.state.accessToken)) {
                    this.setState({loading: true, confirmButtonDisabled: true, confirmButtonName: 'Please Wait'});
                    await this.createAccessTokenForElavon(null, null);
                }

                await this.getElavonPayment();
            } else if (this.state.order.provider == "ELAVON" && Number.isInteger(this.state.paymentOption)) {
                // Saved Elavon card:
                // - If backend returns redirectUrl -> payment-link fullPageRedirect flow (legacy).
                // - If backend returns no redirectUrl -> hosted-fields CVV flow (feature-flagged on backend).
                this.setState({loading: true, confirmButtonDisabled: true, confirmButtonName: 'Please Wait'});
                let selectedCard = null;
                this.state.cardList.forEach(itemSub => {
                    if (itemSub.id == this.state.paymentOption) {
                        selectedCard = itemSub;
                    }
                });
                if (selectedCard) {
                    this.setState({ cardIdentifier: selectedCard.crossReference });
                    await this.createAccessTokenForElavon(selectedCard.crossReference, selectedCard.id);
                }

                if (!GeneralUtils.isNullOrEmpty(this.state.elavonRedirectUrl)) {
                    // Legacy redirect flow: persist basket fields first, save paymentLink for polling, then redirect.
                    if (this.refOrderCheckout != null) {
                        const orderData = this.refOrderCheckout.getData();
                        const draft = {
                            basketDetailList: orderData.checkOutItemList,
                            orderNotes: this.state.order.orderNotes,
                            allergies: this.state.order.allergies,
                            orderType: this.state.order.orderType,
                            orderTimeForDelivery: this.state.order.orderTimeForDelivery,
                            tableBssId: this.state.order.orderType == "Table Order" ? this.state.order.tableBssId : null,
                            memberUserAddress: this.state.memberUserAddress,
                            memberBillingAddress: this.state.sameAsDeliveryAddress == true ? this.state.memberUserAddress : this.state.memberBillingAddress,
                            id: orderData.id,
                            saveCard: false,
                            paymentAccessToken: null,
                            cardIdentifier: selectedCard ? selectedCard.crossReference : this.state.cardIdentifier,
                            paymentType: "CARD",
                            cardNumber: Number.isInteger(this.state.paymentOption) ? this.state.paymentOption : null,
                            website: GeneralUtils.getUiUrl(),
                            notificationURL: SERVER_URL
                        };
                        const prepared = await this.basketService.prepareOrder(draft);
                        if (!GeneralUtils.isNullOrEmpty(prepared) && !GeneralUtils.isNullOrEmpty(prepared.type)) {
                            this.setState({loading: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                            return toast.warn(prepared.message || "An unexpected error has occurred.");
                        }
                    }
                    if (this.refOrderCheckout != null && !GeneralUtils.isNullOrEmpty(this.state.elavonPaymentLink)) {
                        const orderData = this.refOrderCheckout.getData();
                        if (orderData && orderData.id) {
                            await this.basketService.updateElavonPaymentLink(orderData.id, this.state.elavonPaymentLink);
                        }
                    }
                    window.location.href = this.state.elavonRedirectUrl;
                    return;
                }

                // Hosted-fields saved-card flow: submit CVV (and potentially trigger 3DS) in-page.
                await this.getElavonPayment();
            } else if ((this.state.order.provider == "OPAYO" || this.state.order.provider == "ELAVON" || this.state.order.provider == "DNA") && this.state.paymentOption == "APPLE PAY") {
                if (this.refOrderCheckout != null) {
                    var validations = this.checkValidations();
                    if (!GeneralUtils.isNullOrEmpty(validations)) {
                        this.setState({loading: false, applePaySheetOpen: false, confirmButtonDisabled: false, confirmButtonName: 'Confirm Order'});
                        return toast.warn(validations);
                    } else {
                        this.tokeniseApplePay();
                    }
                }


            } else {
                this.confirmOrder();
            }
        } else {
            return toast.warn(validations);
        }
    }

    renderPayment() {

        if (this.state.paymentOption == "APPLE PAY") {
            document.getElementById('apple-pay-button').style.display = "block";
            document.getElementById('apple-pay-button').style.width = "100%"
            document.getElementById('apple-pay-button').style.marginBottom = "5px";
            document.getElementById('apple-pay-button').style.borderRadius = "5px";
            document.getElementById('apple-pay-button').style.padding = "5px 0px";

        } else {
            let applePayButton = document.getElementById('apple-pay-button');
            if (applePayButton != null) {
                applePayButton.style.display = "none";
            }
        }

        let disableCancelButton = true;
        if(this.refOrderCheckout != undefined && this.refOrderCheckout.getData().checkOutItemList.length>0){
            disableCancelButton = false;
        }

        return (<div>
            {this.renderCollapsibleCheckoutPanel({
                stateKey: 'checkoutPaymentPanelOpen',
                buttonId: 'co-checkout-payment-heading',
                bodyId: 'co-checkout-payment-panel-body',
                contentKey: 'order.checkout.payment',
                fallback: 'Payment',
                children: (
                    <React.Fragment>
                        {this.renderPaymentMethods()}

                        <div className="checkout-payment-actions">
                            <Row>
                                <Col xs={12}>
                                    <apple-pay-button id="apple-pay-button" style={{display: "none"}}
                                                      buttonstyle="white-outline" type="check-out"
                                                      locale="en-GB">
                                    </apple-pay-button>

                                    {this.state.paymentOption != "WALLET" && this.state.paymentOption != "APPLE PAY" &&
                                        <Button color="primary"
                                                className="checkout-action-btn mb-2"
                                                disabled={this.state.confirmButtonDisabled}
                                                onClick={() => {
                                                    this.onClickConfirmOrderButton()
                                                }}>
                                            <Translate contentKey="entity.action.add">{this.state.confirmButtonName}</Translate>
                                        </Button>
                                    }
                                </Col>
                            </Row>

                            <Row className="checkout-secondary-actions">
                                <Col xs={6}>
                                    <Button color="outline-danger"
                                            className="checkout-action-btn"
                                            disabled={false}
                                            onClick={() => {

                                                this.setState({loading: true});
                                                this.basketService.cancelOrder(localStorage.getItem("merchantBranchId")).then((response) => {
                                                    this.reloadPage("?cancelledMessage=true")
                                                    this.setState({loading: false});
                                                });


                                            }}>
                                        <Translate contentKey="entity.action.add">Cancel Order</Translate>
                                    </Button>
                                </Col>
                                <Col xs={6}>
                                    <Button color="outline-primary"
                                            className="checkout-action-btn"
                                            disabled={false}
                                            onClick={() => {
                                                this.reloadPage("")

                                            }}>
                                        <Translate contentKey="entity.action.add">Continue Shopping</Translate>
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </React.Fragment>
                )
            })}
        </div>);
    }


    renderCheckOut() {
        return <OrderCheckOut ref={(elem) => this.refOrderCheckout = elem}
                              refreshBasket={this.refreshBasket}
                              createDojoTokenAgain={this.createDojoTokenAgain}
                              openItemDetails={this.openItemDetails}
                              initialYourOrderOpen={!GeneralUtils.isMobile()}></OrderCheckOut>;

    }

    refreshBasket =  () => {
        this.getBasketInfo(this.state.order.orderType);
    }

    getBasketInfo = async (orderType) => {
        if (GeneralUtils.isAuthenticated() && (GeneralUtils.hasWebOrderLicense() || GeneralUtils.hasTableOrderLicense())) {

            const response = (await this.basketService.findBasketCreatedByMerchantBranchId(localStorage.getItem("merchantBranchId"), orderType));
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("tableBssId"))) {
                    let order = this.state.order;
                    order["tableBssId"] = localStorage.getItem("tableBssId");
                    this.setState({order: order});
                } else {
                    let order = this.state.order;
                    order["tableBssId"] = response.tableBssId;
                    this.setState({order: order});
                }
                if (this.refOrderCheckout != null) {
                    this.refOrderCheckout.setPageMode(PAGE_MODE.VIEW);
                    this.refOrderCheckout.setData(response);
                }

            }
        }
    }

    __handleChangeOrder = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let order = this.state.order;
        order[e.target.name] = value;
        this.setState({order: order});
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let memberUserCard = this.state.memberUserCard;
        memberUserCard[e.target.name] = value;
        this.setState({memberUserCard: memberUserCard});
    }

    __handleChangeAddress = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let memberUserAddress = this.state.memberUserAddress;
        memberUserAddress[e.target.name] = value;
        if (!GeneralUtils.isNullOrEmpty(value) && value.postCode !== undefined) {
            memberUserAddress = this.getAddressDetailFromFilteredCombo(value)
        }
        this.setState({memberUserAddress: memberUserAddress});


    }

    __handleChangeBillingAddress = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let memberBillingAddress = this.state.memberBillingAddress;
        memberBillingAddress[e.target.name] = value;
        if (!GeneralUtils.isNullOrEmpty(value) && value.postCode !== undefined) {
            memberBillingAddress = this.getAddressDetailFromFilteredCombo(value)
        }
        this.setState({memberBillingAddress: memberBillingAddress});
    }

    normalizeLookupAddressOptions(response) {
        if (!Array.isArray(response)) {
            return [];
        }
        return response
            .filter((el) => el != null && String(el.displayString != null ? el.displayString : "").trim() !== "")
            .map((el) => {
                const ds = String(el.displayString != null ? el.displayString : "").trim();
                return ds.toLowerCase() === "other" ? Object.assign({}, el, {displayString: "New"}) : el;
            });
    }

    searchAddress = (e) => {

        if (this.state.memberUserAddress.postCode != null && this.state.memberUserAddress.postCode.length >= 6) {
            this.addressService.getAddresses(localStorage.getItem("merchantBranchId"), this.state.memberUserAddress.postCode).then(response => {
                const normalized = this.normalizeLookupAddressOptions(response);
                this.setState({filteredAddresses: normalized});
                if (normalized.length > 0) {
                    e.which = 99;
                    this.dropDownAddress.onInputKeyDown(e);
                } else {
                    return toast.info("No Available Address");
                }


            });

        } else {
            this.setState({filteredAddresses: []});
        }

    }

    searchBillingAddress = (e) => {
        if (this.state.memberBillingAddress.postCode != null && this.state.memberBillingAddress.postCode.length >= 6) {
            this.addressService.getAddresses(localStorage.getItem("merchantBranchId"), this.state.memberBillingAddress.postCode).then(response => {
                const normalized = this.normalizeLookupAddressOptions(response);
                this.setState({filteredBillingAddresses: normalized});
                if (normalized.length > 0) {
                    e.which = 99;
                    this.dropDownBillingAddress.onInputKeyDown(e);
                } else {
                    return toast.info("No Available Address");
                }

            });

        } else {
            this.setState({filteredBillingAddresses: []});
        }

    }

    getAddressDetail = (displayString) => {
        return this.state.filteredAddresses.filter(function (el) {
            return el.displayString == displayString;
        });
    }

    getBillingAddressDetail = (displayString) => {
        return this.state.filteredBillingAddresses.filter(function (el) {
            return el.displayString == displayString;
        });
    }

    createDojoTokenAgain = () => {
        if (this.state.order.provider === "DOJO") {
            if (Number.isInteger(this.state.paymentOption) || (this.state.paymentOption == "CARD" || this.state.paymentOption == "WALLET")) {
                this.removeCardIframes();
                this.createAccessTokenForDojo(this.state.crossReference, this.state.paymentOption)

            }
        }

    }

    getAddressDetailById = (id) => {
        let data = this.state.addressList.filter(function (el) {
            return el.id == id;
        });
        if (!GeneralUtils.isNullOrEmpty(data)) {
            return this.setAddressToState(data[0]);
        } else {
            return Object.assign({}, defaultMemberUserAddress);
        }

    }

    getBillingAddressDetailById = (id) => {
        let data = this.state.billingAddressList.filter(function (el) {
            return el.id == id;
        });
        if (!GeneralUtils.isNullOrEmpty(data)) {
            return this.setAddressToState(data[0]);
        } else {
            return Object.assign({}, defaultMemberUserAddress);
        }

    }

    getAddressDetailFromFilteredCombo(data) {
        let address = {};
        address["postCode"] = data.postCode;
        address["description"] = data.postCode;
        address["addressLine1"] = data.addressLines[0];
        address["addressLine2"] = data.addressLines[1];
        address["addressLine3"] = data.addressLines[2];
        address["addressLine4"] = data.addressLines[3];
        address["city"] = data.postTown;
        return address;
    }


}

